class PageCheckoutPH extends HTMLElement {
  constructor() {
    super();
    this.inicializarEstadosYProcesos();
    this.inicializarInformacionUsuario();
    this.inicializarSucursalesYUbicaciones();
    this.inicializarCarritoYProductos();
    this.inicializarOrdenesYPedidos();
    this.inicializarApisYServicios();
  }

  inicializarEstadosYProcesos() {
    // ESTADO METODO DE ENTREGA
    this.estadoPagina = localStorage.getItem("ph-metodo-entrega") || "domicilio";

    // ESTADO PROCESO DIRECCIÓN
    this.estadoProcesoDireccion = "";
    this.estadoFaseNuevaDireccion = 1;
    this.huboPreSeleccionaDireccionDomicilio = false;

    this.metodoPagoSeleccionado = null;

    this.coordenadasProcesoNuevaDireccion = null;
    this.placesService = null;
    this.marcadorMovible = null;
    this.mapa = null;

    this.idUsuariosCallCenter = window.empleadosCallCenter;
  }

  inicializarInformacionUsuario() {
    this.usuario = JSON.parse(localStorage.getItem("ph-datos-usuario"));
    this.tipoUsuario = localStorage.getItem("ph-tipo-usuario") || "";
    this.listaDireccionesGuardadas = JSON.parse(
      localStorage.getItem("ph-datos-usuario")
    ).direcciones || [
        {
          lat: -17.783315017953004,
          lng: -63.18214577296119,
          indicaciones: "Puente Urubo 91, Santa Cruz de la Sierra",
          alias: "Ubicación de entrega",
        },
      ];

    // Limpiar duplicados de "Ubicación de entrega" - mantener solo el último
    const indicesUbicacion = this.listaDireccionesGuardadas
      .map((d, i) => (d.alias == "Ubicación de entrega" || d.alias == "Ubicacion de entrega") ? i : -1)
      .filter(i => i !== -1);

    if (indicesUbicacion.length > 1) {
      const ultimoIndice = indicesUbicacion[indicesUbicacion.length - 1];
      this.listaDireccionesGuardadas = this.listaDireccionesGuardadas.filter((d, i) =>
        !(d.alias == "Ubicación de entrega" || d.alias == "Ubicacion de entrega") || i == ultimoIndice
      );

      const datosUsuario = JSON.parse(localStorage.getItem("ph-datos-usuario"));
      datosUsuario.direcciones = this.listaDireccionesGuardadas;
      localStorage.setItem("ph-datos-usuario", JSON.stringify(datosUsuario));
    }
  }

  inicializarSucursalesYUbicaciones() {
    this.sucursales = window.sucursales;
    this.localSeleccionado = null;
    this.direccionSeleccionado = null;
    this.sucursal = GestionSucursales.corroborarInfoShopify(
      this.sucursales,
      JSON.parse(localStorage.getItem("sucursal-informacion"))
    );
  }

  inicializarCarritoYProductos() {
    this.carrito = null;
    this.totalCarrito = 0;
    this.cantidadProductosCarrito = 0;
    this.procesandoPedido = false;
    this.tienenStockLosProductosCarrito = "no";
    this.coleccionesProductosCarrito = [];
  }

  inicializarOrdenesYPedidos() {
    this.orden = null;
    this.nombreOrden = null;
    this.infoUltimaOrden = null;
  }

  inicializarApisYServicios() {
    this.url = `https://qr.farmacorp.com/api/v1`;
    this.user = `fbustos`;
    this.pass = `Fwy8xYfq`;
    this.idQr = null;
  }

  async connectedCallback() {
    this.inicializarReferenciasDOM();
    // this.configurarEventListeners();
    // await this.inicializarConfiguracionInicial();

    // EVENT LISTENERS - METODOS DE ENTREGA

    this.btnMetodoLocal.addEventListener(
      "click",
      this.seleccionarMetodoLocal.bind(this)
    );
    this.btnMetodoDomicilio.addEventListener(
      "click",
      this.seleccionarMetodoDomicilio.bind(this)
    );

    // EVENT LISTENERS - SELECCIÓN DE LOCAL

    this.btnVerDireccionEnMapa.addEventListener(
      "click",
      this.verDireccionEnMapaLocalSeleccionado.bind(this)
    );

    // EVENT LISTENERS - NUEVA DIRECCIÓN

    this.btnAnadirNuevaDireccion.addEventListener(
      "click",
      this.procesoParaAnadirNuevaDireccion.bind(this)
    );
    this.btnCerrarModalNuevaDireccion.addEventListener(
      "click",
      this.cerrarModalNuevaDireccion.bind(this)
    );
    this.btnVolverAtrasNuevaDireccion.addEventListener(
      "click",
      this.procesoVolverAtrasNuevaDireccion.bind(this)
    );
    this.btnMiUbicacionActualF1.addEventListener(
      "click",
      this.procesoMiUbicacionActualF1.bind(this)
    );
    this.btnProcesoPrincipalNd.addEventListener(
      "click",
      this.procesoPrincipalNuevaDireccion.bind(this)
    );
    this.btnCancelarNd.addEventListener(
      "click",
      this.procesoVolverAtrasNuevaDireccion.bind(this)
    );

    // Input validaciones
    this.inputAliasDireccionF3.addEventListener("input", (event) => {
      const query = event.target.value.trim();
      if (query == "" && this.estadoFaseNuevaDireccion == 3) {
        this.btnProcesoPrincipalNd.classList.add("desactivado");
      } else {
        this.btnProcesoPrincipalNd.classList.remove("desactivado");
      }
    });

    // EVENT LISTENERS - DATOS DE CONTACTO Y FACTURACIÓN

    this.btnEditarDatos.addEventListener("click", (event) => {
      this.btnAccionDatosContacto(event.currentTarget);
    });
    this.btnGuardarDatos.addEventListener("click", (event) => {
      this.btnAccionDatosContacto(event.currentTarget);
    });
    this.btnEditarDatosFacturacion.addEventListener("click", (event) => {
      this.btnAccionDatosFacturacion(event.currentTarget);
    });
    this.btnGuardarDatosFacturacion.addEventListener("click", (event) => {
      this.btnAccionDatosFacturacion(event.currentTarget);
    });

    // EVENT LISTENERS - MÉTODOS DE PAGO Y GENERALES

    this.btnsMetodosPagos.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        this.procesoSeleccionMetodoPago(event.currentTarget);
      });
    });
    this.cerrarModalMensaje.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        this.cerrarModalMensajeProceso(event.currentTarget);
      });
    });
    this.btnContinuar.addEventListener(
      "click",
      this.procesoContinuarGeneral.bind(this)
    );
    this.btnHutCoins.addEventListener("click", (event) => {
      this.procesoHutCoins(event.currentTarget);
    });


    // INICIALIZACIÓN - CONFIGURACIÓN MÉTODO DE ENTREGA

    this.etiquetaEnvioDomicilio.textContent =
      this.estadoPagina == "domicilio"
        ? `Bs ${window.costoEnvioDomicilio}`
        : "Bs 0";
    this.direccionSeleccionado = JSON.parse(
      localStorage.getItem("ph-direccion-envio-guardada")
    );

    // Recuperar direccion de envio guardada o usar por defecto
    if (this.direccionSeleccionado == null || this.direccionSeleccionado == undefined) {
      // Verificar que haya direcciones disponibles
      if (this.listaDireccionesGuardadas && this.listaDireccionesGuardadas.length > 0) {
        this.direccionSeleccionado =
          this.listaDireccionesGuardadas.length == 1
            ? this.listaDireccionesGuardadas[0]
            : this.listaDireccionesGuardadas[
            this.listaDireccionesGuardadas.length - 1
            ];
      } else {
        // Si no hay direcciones, usar la dirección por defecto
        this.direccionSeleccionado = {
          lat: -17.783315017953004,
          lng: -63.18214577296119,
          indicaciones: "Puente Urubo 91, Santa Cruz de la Sierra",
          alias: "Ubicación de entrega",
        };
      }
    } else {
      // Buscar la dirección guardada en la lista
      const direccionEncontrada = this.listaDireccionesGuardadas.find(
        (direccion) =>
          direccion.lat == this.direccionSeleccionado.lat &&
          direccion.lng == this.direccionSeleccionado.lng
      );

      if (direccionEncontrada) {
        this.direccionSeleccionado = direccionEncontrada;
      } else if (this.listaDireccionesGuardadas && this.listaDireccionesGuardadas.length > 0) {
        // Si no se encuentra, usar la primera disponible
        this.direccionSeleccionado = this.listaDireccionesGuardadas[0];
      } else {
        // Si no hay direcciones, usar la dirección por defecto
        this.direccionSeleccionado = {
          lat: -17.783315017953004,
          lng: -63.18214577296119,
          indicaciones: "Puente Urubo 91, Santa Cruz de la Sierra",
          alias: "Ubicación de entrega",
        };
      }
    }

    // Asegurar que direccionSeleccionado no sea null antes de continuar
    if (!this.direccionSeleccionado) {
      console.warn("No se pudo inicializar direccionSeleccionado, usando dirección por defecto");
      this.direccionSeleccionado = {
        lat: -17.783315017953004,
        lng: -63.18214577296119,
        indicaciones: "Puente Urubo 91, Santa Cruz de la Sierra",
        alias: "Ubicación de entrega",
      };
    }

    // Guardar la dirección seleccionada en localStorage para futuras referencias
    if (this.direccionSeleccionado) {
      localStorage.setItem(
        "ph-direccion-envio-guardada",
        JSON.stringify(this.direccionSeleccionado)
      );
    }

    // INICIALIZACIÓN - CONFIGURACIÓN DE COMPONENTES

    // Mostrar detalles del local seleccionado
    const detalleLocal = this.querySelector(".pcktph-seleccion-local-detalle");
    detalleLocal.style.display = "flex";

    // Configurar tipo de usuario call center
    if (this.idUsuariosCallCenter.includes(this.usuario.id)) {
      this.tipoUsuario = "call_center";
      this.btnGuardarDatos.style.display = "none";
      this.btnEditarDatosFacturacion.style.display = "none";
    }

    // Inicializar datos
    this.inicializarDatosdeContacto();
    this.inicializarDatosdeFacturacion();
    await this.inicializarDataContruccion();

    console.log("window.metodosPago", window.metodosPago);

    const todosSonTrue =
      window.metodosPago.qr == true &&
      window.metodosPago.tarjeta_credito == true &&
      window.metodosPago.efectivo == true;

    if (todosSonTrue) {
      this.intentoAutoSeleccionMetodoPago();
    }

    // INICIALIZACIÓN - VALIDACIÓN DIRECCIÓN PRESELECCIONADA

    if (
      (this.direccionSeleccionado.alias.includes(
        "Ubicación de entrega"
      ) ||
        this.direccionSeleccionado.alias.includes(
          "Ubicacion de entrega"
        )) &&
      !this.direccionSeleccionado.indicaciones.includes(
        "Plaza Principal de Warnes"
      )
    ) {
      // Solicitar nuevo alias e indicaciones para mejor precisión de entrega
      this.huboPreSeleccionaDireccionDomicilio = true;
    }

    // INICIALIZACIÓN - COORDENADAS Y DISTANCIA

    this.coordenadas = await GestionSucursales.obtenerUbicacion();

    // Calcular distancia y actualizar información
    const distancia = AuxiliaresGlobal.calcularDistanciaEuclidiana(this.coordenadas, {
      lat: this.sucursal.lat,
      lng: this.sucursal.lng,
    });
    this.etiquetaModalLocalSeleccionado.textContent = `Local : ${this.localSeleccionado.nombre
      } (${distancia.toFixed(2)} Km) de tu ubicación`;
    // Actualizar información del local seleccionado
    const infoLocal = this.querySelector(
      ".pcktph-seleccion-local-detalle-info"
    );
    infoLocal.innerHTML = `<p>${this.localSeleccionado.nombre}</p>
      <p>+591 ${this.localSeleccionado.telefono} - ${parseFloat(
      distancia
    ).toFixed(2)} Km</p>
    `;

    this.inputPuntoReferenciaF1.addEventListener("keydown", (event) => {
      // Verificar si la tecla presionada es Enter
      if (event.key == "Enter") {
        // Obtener el valor del input
        const valor = this.inputPuntoReferenciaF1.value.trim();

        // Verificar si tiene contenido
        if (valor) {
          console.log("Valor ingresado:", valor);

          let lat = null;
          let lng = null;

          // Función para extraer coordenadas de diferentes formatos
          const extraerCoordenadas = (texto) => {
            console.log("Analizando texto:", texto);

            // 1. Coordenadas directas: -17.8072737,-63.1899595
            let match = texto.match(/^(-?\d+\.?\d*),\s*(-?\d+\.?\d*)$/);
            if (match) {
              console.log("Patrón 1 - Coordenadas directas encontradas");
              return { lat: parseFloat(match[1]), lng: parseFloat(match[2]) };
            }

            // 2. Patrón 3d y 4d (ubicación exacta del PIN) - PRIORIDAD ALTA
            const latMatch = texto.match(/3d(-?\d+\.?\d*)/);
            const lngMatch = texto.match(/4d(-?\d+\.?\d*)/);
            if (latMatch && lngMatch) {
              console.log("Patrón 2 - 3d/4d encontrado (PIN exacto)");
              return {
                lat: parseFloat(latMatch[1]),
                lng: parseFloat(lngMatch[1]),
              };
            }

            // 3. URLs de Google Maps - Patrón @lat,lng (vista del mapa, no siempre el PIN)
            match = texto.match(/@(-?\d+\.?\d*),(-?\d+\.?\d*)/);
            if (match) {
              console.log("Patrón 3 - @ encontrado");
              return { lat: parseFloat(match[1]), lng: parseFloat(match[2]) };
            }

            // 4. URLs de Google Maps - Patrón q=lat,lng
            match = texto.match(/[?&]q=(-?\d+\.?\d*),(-?\d+\.?\d*)/);
            if (match) {
              console.log("Patrón 4 - q= encontrado");
              return { lat: parseFloat(match[1]), lng: parseFloat(match[2]) };
            }

            // 5. URLs de Google Maps - Patrón ll=lat,lng
            match = texto.match(/[?&]ll=(-?\d+\.?\d*),(-?\d+\.?\d*)/);
            if (match) {
              console.log("Patrón 5 - ll= encontrado");
              return { lat: parseFloat(match[1]), lng: parseFloat(match[2]) };
            }

            // 6. Buscar cualquier par de coordenadas en el texto
            match = texto.match(/(-?\d+\.?\d+),\s*(-?\d+\.?\d+)/);
            if (match) {
              console.log("Patrón 6 - Cualquier coordenada encontrada");
              return { lat: parseFloat(match[1]), lng: parseFloat(match[2]) };
            }

            console.log("No se encontraron coordenadas");
            return null;
          };

          // Intentar extraer coordenadas
          const coordenadas = extraerCoordenadas(valor);

          if (coordenadas) {
            lat = coordenadas.lat;
            lng = coordenadas.lng;

            console.log("Coordenadas extraídas:", lat, lng);
            this.coordenadas = { lat, lng };
            this.coordenadasProcesoNuevaDireccion = this.coordenadas;
            this.procesoMiUbicacionActualF1();
            this.ubicacionObtenida = true;
            this.inputPuntoReferenciaF1.value = "";
          } else {
            console.log("❌ No se pudieron extraer coordenadas");
            alert(
              "No se pudo detectar la ubicación. Intenta con:\n- Coordenadas: -17.7709332,-63.1914902\n- Link de Google Maps"
            );
          }
        }
      }
    });
  }

  inicializarReferenciasDOM() {
    this.inicializarReferenciasEstructuraPrincipal();
    this.inicializarReferenciasMetodosEntrega();
    this.inicializarReferenciasSeleccionLocal();
    this.inicializarReferenciasNuevaDireccion();
    this.inicializarReferenciasDireccionEnvio();
    this.inicializarReferenciasDatosContacto();
    this.inicializarReferenciasMetodosPago();
    this.inicializarReferenciasDatosFacturacion();
    this.inicializarReferenciasCarrito();
    this.inicializarReferenciasElementosAdicionales();
  }

  inicializarReferenciasEstructuraPrincipal() {
    this.seccionCarritoDatos = this.querySelector("#pcktph-detalle-carrito");
    this.contenedorBaseModal = this.querySelector(".ph-background-container-modal");
    this.contenedorBaseMensaje = this.querySelector(".ph-modal-main-mensajes");
    this.contenedorQR = this.querySelector(".ph-modal-body-qr");
  }

  inicializarReferenciasMetodosEntrega() {
    this.btnMetodoLocal = this.querySelector("#phpc-metodo-local");
    this.btnMetodoDomicilio = this.querySelector("#phpc-metodo-domicilio");
    this.etiquetaEnvioDomicilio = this.querySelector("#phpc-etiqueta-envio-domicilio");
    this.btnsSeleccionMetodoEntrega = this.querySelectorAll(".smecph-opcion-metodo");
  }

  inicializarReferenciasSeleccionLocal() {
    this.bodyModalLocalSeleccionado = this.querySelector("#phpc-modal-body-local-seleccionado");
    this.modalBodyContenedorMapa = this.querySelector("#phpc-localSeleccionado-mapa");
    this.etiquetaModalLocalSeleccionado = this.querySelector("#phpc-etiqueta-informacion-modal-local-seleccionado");
    this.etiquetaLocalSeleccionado = this.querySelector("#pcktph-seleccion-local-detalle-info");
    this.btnVerDireccionEnMapa = this.querySelector("#phpc-btn-ver-direccion-mapa");
    this.etiquetaLocalSeleccionadoPrincipal = this.querySelector("#phpc-nombre-local-seleccionado");
    this.contenedorResultadosBuquedaLocal = this.querySelector("#phpc-resultados-seleccion-local");
    this.btnIconoMostrarTodosLocales = this.querySelector("#phpc-mostrar-todos-locales");
    this.contenedorLocalSeleccionado = this.querySelector("#phpc-local-preseleccionado");
    this.contenedorBaseSeleccionLocal = this.querySelector("#pcktph-seleccion-local");
  }

  inicializarReferenciasNuevaDireccion() {
    // Modal y estructura
    this.contenedorModalMapaNuevaDireccion = this.querySelector("#phpc-modal-nd-mapa");
    this.btnAnadirNuevaDireccion = this.querySelector("#phpc-btn-anadir-nueva-direccion");
    this.btnCerrarModalNuevaDireccion = this.querySelector("#phpc-btn-cerrar-modal-nuevadireccion");
    this.modalBodyNuevaDireccion = this.querySelector("#phpc-modal-body-nueva-direccion");
    this.footerModalNuevaDireccion = this.querySelector("#phpc-modal-footer-nd");
    this.etiquetaBtnModalNuevaDireccion = this.querySelector("#phpc-etiqueta-btn-acciones");

    // Navegación y botones
    this.btnVolverAtrasNuevaDireccion = this.querySelector("#phpc-btn-modal-volver-atras");
    this.btnProcesoPrincipalNd = this.querySelector("#phpc-btn-proceso-principal-nd");
    this.btnCancelarNd = this.querySelector("#phpc-btn-cancelar-nd");

    // Fase 1
    this.modalContenidoF1NuevaDireccion = this.querySelector("#phpc-modal-nd-fase1");
    this.btnMiUbicacionActualF1 = this.querySelector("#phpc-btn-miubicacionactual-nd");
    this.inputPuntoReferenciaF1 = this.querySelector("#phpc-input-punto-referencia-nd");
    this.contenedorResultadosBusquedaReferenciasF1 = this.querySelector("#phpc-resultados-sugerencias-referencia");

    // Fase 2
    this.modalContenidoF2NuevaDireccion = this.querySelector("#phpc-modal-nd-fase2");

    // Fase 3
    this.modalContenidoF3NuevaDireccion = this.querySelector("#phpc-modal-nd-fase3");
    this.inputIndicacionesDireccionF3 = this.querySelector("#phpc-input-indicaciones-nd");
    this.inputAliasDireccionF3 = this.querySelector("#phpc-input-alias-nd");
  }

  inicializarReferenciasDireccionEnvio() {
    this.contenedorResultadosBusquedaDireccion = this.querySelector("#phpc-resultados-seleccion-direccion-envio");
    this.contenedorBaseSeleccionDireccionEnvio = this.querySelector("#phpc-seccion-seleccion-local");
    this.contenedorDireccionEnvioSeleccionado = this.querySelector("#phpc-direccion-envio-de-uso");
    this.etiquetaAliasDireccion = this.querySelector("#phpc-alias-direccion-envio");
    this.etiquetaIndicacionesDireccion = this.querySelector("#phpc-referencias-direccion-envio");
  }

  inicializarReferenciasDatosContacto() {
    // Formulario y contenedores
    this.seccionFormDatosContacto = this.querySelector("#phpc-sector-datos-contacto");
    this.contenedorDatosContactoInputsForm = this.querySelector(".smecph-formulario-datos-contacto");
    this.contenedorDatosContactoConsolidados = this.querySelector(".smecph-datos-contacto-consolidados");
    this.formDatosContacto = this.querySelector("#phpc-form-datos-contacto");
    this.contenedorDatoContactoConsolidados = this.querySelector("#phpc-datos-contacto-consolidados");
    this.etiquetaDatosConsolidados = this.querySelector("#phpc-etiqueta-datos-consolidados");
    this.contenedorDatosContactoEditar = this.querySelector("#phpc-form-datos-contacto");

    // Botones
    this.btnEditarDatos = this.querySelector("#phpc-btn-editar-datos-contacto");
    this.btnGuardarDatos = this.querySelector("#phpc-btn-guardar-datos-contacto");

    // Inputs y alertas
    this.inputNombreContacto = this.querySelector("#phpc-input-nombre-contacto");
    this.alertaNombreContacto = this.querySelector("#phpc-alerta-nombre-contacto");
    this.inputApellidoContacto = this.querySelector("#phpc-input-apellido-contacto");
    this.alertaApellidoContacto = this.querySelector("#phpc-alerta-apellido-contacto");
    this.inputCorreoElectronico = this.querySelector("#phpc-input-correo-contacto");
    this.alertaCorreoElectronico = this.querySelector("#phpc-alerta-correo-contacto");
    this.inputCelularContacto = this.querySelector("#phpc-input-celular-contacto");
    this.alertaCelularContacto = this.querySelector("#phpc-alerta-celular-contacto");
    this.mensajeInfoCelularContacto = this.querySelector("#phpc-mensaje-info-celular-contacto");
    this.inputCIContacto = this.querySelector("#phpc-input-ci-contacto");
    this.alertaCIContacto = this.querySelector("#phpc-alerta-ci-contacto");
  }

  inicializarReferenciasMetodosPago() {
    this.seccionGeneralMetodosPago = this.querySelector("#phpc-sector-metodos-de-pago");
    this.mensajeAlertaSeleccionMetodoPago = this.querySelector(".smecph-mensaje-alerta");
    this.mensajeAlertaDatosFacturacion = this.querySelector("#phpc-mensaje-alerta-datos-facturacion");
    this.btnsMetodosPagos = this.querySelectorAll(".smecph-pc-dp-item");

    // Tarjeta de crédito
    this.opcionesTarjetaCredito = this.querySelector("#phpc-opciones-tarjeta-credito");
    this.inputPrimero4Digitos = this.querySelector("#phpc-input-primero-4-digitos");
    this.mensajeAlertaPrimero4Digitos = this.querySelector("#phpc-alerta-primero-4-digitos");
    this.inputUltimos4Digitos = this.querySelector("#phpc-input-ultimos-4-digitos");
    this.mensajeAlertaUltimos4Digitos = this.querySelector("#phpc-alerta-ultimos-4-digitos");
    // this.btnsMetodosPagos = this.querySelectorAll("#phpc-btn-metodo-pago");
  }

  inicializarReferenciasDatosFacturacion() {
    this.etiquetaDatosFacturacionConsolidados = this.querySelector("#phpc-etiqueta-datos-facturacion-consolidados");
    this.contenedorDatosFacturacion = this.querySelector("#phpc-form-datos-facturacion");
    this.contenedorDatosFacturacionConsolidados = this.querySelector("#phpc-datos-facturacion-consolidados");
    this.btnEditarDatosFacturacion = this.querySelector("#phpc-btn-editar-datos-facturacion");
    this.btnGuardarDatosFacturacion = this.querySelector("#phpc-btn-guardar-datos-facturacion");
    this.inputRazonSocial = this.querySelector("#phpc-input-razon-social");
    this.inputNitoCit = this.querySelector("#phpc-input-nit-cit");
  }

  inicializarReferenciasCarrito() {
    this.btnEditarCarrito = this.querySelector("#phpc-btn-editar-carrito");
    this.contenedorItemsCarrito = this.querySelector("#phpc-contenedor-items-carrito");
    this.etiquetaSubtotal = this.querySelector("#phpc-etiqueta-subtotal");
    this.etiquetaDescuento = this.querySelector("#phpc-etiqueta-descuento");
    this.etiquetaTotal = this.querySelector("#phpc-etiqueta-total");
  }

  inicializarReferenciasElementosAdicionales() {
    this.contenedorHutCoins = this.querySelector("#phpc-hutcoins");
    this.btnHutCoins = this.querySelector("#phpc-btn-hutcoins");
    this.inputFechaNacimiento = this.querySelector("#phpc-input-fecha-nacimiento");
    this.inputNotaParaElPedido = this.querySelector("#phpc-info-adicional-notapedido");
    this.inputCodigoCupon = this.querySelector("#phpc-input-codigo-cupon");
    this.btnAplicarCupon = this.querySelector("#phpc-btn-aplicar-cupon");
    this.cerrarModalMensaje = this.querySelectorAll("#phpc-btn-cerrar-modal");
    this.btnContinuar = this.querySelector("#phpc-btn-continuar-general");
  }

  configurarEventListeners() {
    // this.configurarEventListenersMetodosEntrega();
    // this.configurarEventListenersSeleccionLocal();
    // this.configurarEventListenersNuevaDireccion();
    // this.configurarEventListenersDatosContacto();
    // this.configurarEventListenersMetodosPago();
    // this.configurarEventListenersGenerales();
  }


  inicializarDatosdeContacto() {
    // Obtener datos del usuario
    const data = this.usuario;

    // Evaluar que tipo de usuario es (Empleado Call Center) o (Cliente)
    if (this.tipoUsuario == "call_center") {
      // Configuracion para call center - Formulario vacio
      this.inputNombreContacto.value = "";
      this.inputApellidoContacto.value = "";
      this.inputCorreoElectronico.value = "";
      this.inputCelularContacto.value = "";
      this.inputCIContacto.value = "";
      this.btnEditarDatos.style.display = "none";
      this.btnGuardarDatos.style.display = "none";
      this.contenedorDatosContactoEditar.style.display = "flex";
      this.contenedorDatoContactoConsolidados.style.display = "none";
    } else {
      // Configuracion para usuario normal (cliente)

      const esUsuarioPrimerizo =
        data.nombre?.includes("pizzaHut") ||
        data.apellido?.includes("pizzaHut") ||
        data.email?.includes("pizzaHut") ||
        data.nombre?.includes("sin nombre") ||
        data.apellido?.includes("sin nombre") ||
        data.nombre?.includes("sinnombre") ||
        data.apellido?.includes("sinnombre");

      if (esUsuarioPrimerizo) {
        this.inputNombreContacto.value = "";
        this.inputApellidoContacto.value = "";
        this.inputCorreoElectronico.value = "";
        this.inputCelularContacto.value = data.celular;
        this.inputCIContacto.value = data.ci;
        this.btnEditarDatos.style.display = "none";
        this.btnGuardarDatos.style.display = "flex";
        this.contenedorDatosContactoEditar.style.display = "flex";
        this.contenedorDatoContactoConsolidados.style.display = "none";
      } else {
        this.inputNombreContacto.value = data.nombre;
        this.inputApellidoContacto.value = data.apellido;
        this.inputCorreoElectronico.value = data.email;
        this.inputCelularContacto.value = data.celular;
        this.inputCIContacto.value = data.ci;
        this.etiquetaDatosConsolidados.textContent = `${data.nombre} | ${data.apellido} | ${data.email} | +591 ${data.celular} | ${data.ci}`;
        this.btnEditarDatos.style.display = "flex";
        this.btnGuardarDatos.style.display = "none";
        this.contenedorDatosContactoEditar.style.display = "none";
        this.contenedorDatoContactoConsolidados.style.display = "flex";
      }
    }
  }

  inicializarDatosdeFacturacion() {
    const data = JSON.parse(localStorage.getItem("ph-datos-usuario"));
    if (this.tipoUsuario == "call_center") {
      this.contenedorDatosFacturacion.style.display = "flex";
      this.contenedorDatosFacturacionConsolidados.style.display = "none";
    } else {
      if (data.razon_social == "" || data.nit == "") {
        this.inputRazonSocial.value = "";
        this.inputNitoCit.value = "";
      } else {
        this.inputRazonSocial.value = data.razon_social;
        this.inputNitoCit.value = data.nit;
      }
      this.etiquetaDatosFacturacionConsolidados.textContent = `${this.inputRazonSocial.value} | ${this.inputNitoCit.value}`;
    }
  }

  async inicializarDataContruccion() {
    MensajeCargaDatos.mostrar("Cargando información del pagina ...");

    if (this.estadoPagina == "domicilio") {
      this.contenedorBaseSeleccionDireccionEnvio.style.display = "flex";
      this.contenedorBaseSeleccionLocal.style.display = "none";
      this.btnMetodoDomicilio.classList.add("seleccionado");
      const iconoSeleccionado = this.btnMetodoDomicilio.querySelector(
        ".smecph-opcion-icono"
      );
      iconoSeleccionado.innerHTML = window.shopIcons.icon_estado_on;
      var auxiliar = this.btnMetodoDomicilio.querySelector(
        ".smecph-opcion-info"
      );
      auxiliar.classList.add("icon-color-secondary");
    }

    if (this.estadoPagina == "local") {
      this.contenedorBaseSeleccionDireccionEnvio.style.display = "none";
      this.contenedorBaseSeleccionLocal.style.display = "flex";
      this.btnMetodoLocal.classList.add("seleccionado");
      const iconoSeleccionado = this.btnMetodoLocal.querySelector(
        ".smecph-opcion-icono"
      );
      iconoSeleccionado.innerHTML = window.shopIcons.icon_estado_on;
      var auxiliar = this.btnMetodoLocal.querySelector(".smecph-opcion-info");
      auxiliar.classList.add("icon-color-secondary");
    }

    await this.construccionSeccionItemsCarrito();
    this.configuracionAutoCompletadoSeleccionLocal();
    this.configuracionAutoCompletadoSeleccionDireccion();
    this.configuracionAutoCompletadoPuntosReferencia();

    this.sucursales = window.sucursales;

    if (this.estadoPagina == "domicilio") {
      this.sucursal = AuxiliaresGlobal.obtenerSucursalTrabajo({
        lat: this.direccionSeleccionado.lat,
        lng: this.direccionSeleccionado.lng,
      });

      localStorage.setItem(
        "sucursal-informacion",
        JSON.stringify(this.sucursal)
      );
    }

    this.localSeleccionado = this.sucursal;
    console.log("Local seleccionado : ", this.localSeleccionado);
    this.etiquetaLocalSeleccionadoPrincipal.textContent =
      this.localSeleccionado.nombre;

    this.etiquetaAliasDireccion.textContent =
      this.direccionSeleccionado.alias;
    this.etiquetaIndicacionesDireccion.textContent =
      this.direccionSeleccionado.indicaciones;

    await this.inspeccionTodosProductosCarrito();
    MensajeCargaDatos.ocultar();
  }

  async seleccionarMetodoLocal() {
    this.estadoPagina = "local";
    this.etiquetaEnvioDomicilio.textContent = "Bs 0";
    var etiquetaTotal = this.querySelector("#phpc-etiqueta-total");
    etiquetaTotal.textContent = `Bs ${this.totalCarrito.toFixed(2)}`;
    this.contenedorBaseSeleccionDireccionEnvio.style.display = "none";
    this.contenedorBaseSeleccionLocal.style.display = "flex";
    this.btnMetodoLocal.classList.add("seleccionado");
    const iconoSeleccionado = this.btnMetodoLocal.querySelector(
      ".smecph-opcion-icono"
    );
    iconoSeleccionado.innerHTML = window.shopIcons.icon_estado_on;
    var auxiliar = this.btnMetodoLocal.querySelector(".smecph-opcion-info");
    auxiliar.classList.add("icon-color-secondary");

    this.btnMetodoDomicilio.classList.remove("seleccionado");
    const iconoDesSeleccionado = this.btnMetodoDomicilio.querySelector(
      ".smecph-opcion-icono"
    );
    iconoDesSeleccionado.innerHTML = window.shopIcons.icon_estado_off;
    var auxiliar1 = this.btnMetodoDomicilio.querySelector(
      ".smecph-opcion-info"
    );
    auxiliar1.classList.remove("icon-color-secondary");

    localStorage.setItem("ph-metodo-entrega", this.estadoPagina);

    // Buscar la instancia del elemento HeaderPrincipal en el DOM
    const headerInstance = document.querySelector("header-principal");

    if (
      headerInstance &&
      typeof headerInstance.verificarEstadoEntrega == "function"
    ) {
      headerInstance.verificarEstadoEntrega();
    } else {
      console.error("No se encontró la instancia de HeaderPrincipal");
    }

    this.sucursal = this.localSeleccionado;
    localStorage.setItem(
      "sucursal-informacion",
      JSON.stringify(this.localSeleccionado)
    );
    console.log("Seleccionando local : ", this.sucursal);
    await this.inspeccionTodosProductosCarrito();
  }

  async seleccionarMetodoDomicilio() {
    // Obtener la sucursal más cercana basada en la dirección seleccionada
    const sucursalCercana = AuxiliaresGlobal.obtenerSucursalTrabajo({
      lat: this.direccionSeleccionado.lat,
      lng: this.direccionSeleccionado.lng,
    });

    this.estadoPagina = "domicilio";
    this.etiquetaEnvioDomicilio.textContent = `Bs ${window.costoEnvioDomicilio}`;
    var etiquetaTotal = this.querySelector("#phpc-etiqueta-total");
    etiquetaTotal.textContent = `Bs ${(
      this.totalCarrito + window.costoEnvioDomicilio
    ).toFixed(2)}`;
    this.contenedorBaseSeleccionDireccionEnvio.style.display = "flex";
    this.contenedorBaseSeleccionLocal.style.display = "none";
    this.btnMetodoDomicilio.classList.add("seleccionado");
    const iconoSeleccionado = this.btnMetodoDomicilio.querySelector(
      ".smecph-opcion-icono"
    );
    iconoSeleccionado.innerHTML = window.shopIcons.icon_estado_on;
    var auxiliar = this.btnMetodoDomicilio.querySelector(".smecph-opcion-info");
    auxiliar.classList.add("icon-color-secondary");

    this.btnMetodoLocal.classList.remove("seleccionado");
    var auxiliar1 = this.btnMetodoLocal.querySelector(".smecph-opcion-info");
    auxiliar1.classList.remove("icon-color-secondary");
    const iconoDesSeleccionado = this.btnMetodoLocal.querySelector(
      ".smecph-opcion-icono"
    );
    iconoDesSeleccionado.innerHTML = window.shopIcons.icon_estado_off;
    localStorage.setItem("ph-metodo-entrega", this.estadoPagina);

    // Buscar la instancia del elemento HeaderPrincipal en el DOM
    const headerInstance = document.querySelector("header-principal");

    if (
      headerInstance &&
      typeof headerInstance.verificarEstadoEntrega == "function"
    ) {
      headerInstance.verificarEstadoEntrega();
    } else {
      console.error("No se encontró la instancia de HeaderPrincipal");
    }

    this.sucursal = sucursalCercana;

    localStorage.setItem(
      "sucursal-informacion",
      JSON.stringify(this.sucursal)
    );

    this.localSeleccionado = this.sucursal;
    this.etiquetaLocalSeleccionadoPrincipal.textContent =
      this.localSeleccionado.nombre;

    await this.inspeccionTodosProductosCarrito();
  }

  verDireccionEnMapaLocalSeleccionado() {
    this.modalBodyNuevaDireccion.style.display = "none";

    // Verificar que existe el contenedor para el mapa
    this.modalBodyContenedorMapa = this.querySelector(
      "#phpc-localSeleccionado-mapa"
    );

    if (!this.modalBodyContenedorMapa) {
      console.error("No se encontró el contenedor del mapa");
      return;
    }

    // Verificar que tenemos un local seleccionado
    if (!this.localSeleccionado) {
      console.error("No hay un local seleccionado");
      return;
    }

    // Asegurarse de que el contenedor del mapa sea visible
    // this.modalBodyContenedorMapa.style.display = 'flex';
    this.contenedorBaseModal.style.display = "flex";
    this.bodyModalLocalSeleccionado.style.display = "flex";

    // Coordenadas del local seleccionado
    const posicion = {
      lat: this.localSeleccionado.lat,
      lng: this.localSeleccionado.lng,
    };

    // Opciones del mapa
    const opcionesMapa = {
      center: posicion,
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      streetViewControl: false,
    };

    // Crear el mapa
    const mapa = new google.maps.Map(
      this.modalBodyContenedorMapa,
      opcionesMapa
    );

    // Crear icono personalizado
    const iconoPersonalizado = {
      url: window.assets.logo_primario,
      scaledSize: new google.maps.Size(40, 40),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(20, 40),
    };
  }

  solicitarPermisosDelUsoGPSDispositivo() {
    return new Promise((resolve, reject) => {
      // Verificar si la geolocalización está disponible en el navegador
      if (!navigator.geolocation) {
        const mensaje =
          "La geolocalización no está disponible en este navegador.";
        alert(mensaje);
        console.error(mensaje);
        reject(mensaje);
        return;
      }

      // Opciones de geolocalización
      const options = {
        enableHighAccuracy: true, // Alta precisión
        timeout: 10000, // 10 segundos de timeout
        maximumAge: 0, // No usar cache
      };

      // Función de éxito
      const success = (position) => {
        // Actualizar las coordenadas con la ubicación actual
        this.coordenadas = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        console.log("Ubicación obtenida:", this.coordenadas);
        resolve(this.coordenadas);
      };

      // Función de error
      const error = (err) => {
        let mensaje = "";

        switch (err.code) {
          case err.PERMISSION_DENIED:
            mensaje =
              "Has denegado el permiso para acceder a tu ubicación. No podremos mostrarte los locales más cercanos.";
            break;
          case err.POSITION_UNAVAILABLE:
            mensaje =
              "La información de ubicación no está disponible en este momento.";
            break;
          case err.TIMEOUT:
            mensaje = "Se agotó el tiempo para obtener tu ubicación.";
            break;
          default:
            mensaje = "Ocurrió un error desconocido al obtener tu ubicación.";
            break;
        }

        // Mostrar alerta al usuario
        alert(mensaje);
        console.error("Error de geolocalización:", mensaje);
        reject(mensaje);
      };

      // Solicitar la geolocalización
      navigator.geolocation.getCurrentPosition(success, error, options);
    });
  }

  cerrarModalLocalSeleccionado() {
    this.contenedorBaseModal.style.display = "none";
    this.bodyModalLocalSeleccionado.style.display = "none";
  }

  procesoParaAnadirNuevaDireccion() {
    if (this.huboPreSeleccionaDireccionDomicilio == true) {
      console.log(
        "Preselección de dirección de domicilio detectada, iniciando proceso de nueva dirección...",
        {
          tipoUsuario: this.tipoUsuario,
        }
      );
      this.contenedorBaseModal.style.display = "flex";
      this.modalBodyNuevaDireccion.style.display = "flex";
      this.modalContenidoF1NuevaDireccion.style.display = "none";
      this.modalContenidoF2NuevaDireccion.style.display = "flex";
      this.footerModalNuevaDireccion.style.display = "flex";
      this.estadoFaseNuevaDireccion = 2;
      this.procesoPrincipalNuevaDireccion();
      return;
    }

    this.bodyModalLocalSeleccionado.style.display = "none";
    this.contenedorBaseModal.style.display = "flex";
    this.modalBodyNuevaDireccion.style.display = "flex";
    this.estadoFaseNuevaDireccion = 1;
    this.modalContenidoF1NuevaDireccion.style.display = "flex";
  }

  cerrarModalNuevaDireccion() {
    this.contenedorBaseModal.style.display = "none";
    this.modalBodyNuevaDireccion.style.display = "none";
    this.estadoFaseNuevaDireccion = 1;
    this.modalContenidoF1NuevaDireccion.style.display = "none";
    this.modalContenidoF2NuevaDireccion.style.display = "none";
    this.modalContenidoF3NuevaDireccion.style.display = "none";
    this.footerModalNuevaDireccion.style.display = "none";
    this.btnProcesoPrincipalNd.classList.remove("desactivado");
  }

  procesoVolverAtrasNuevaDireccion() {
    if (this.huboPreSeleccionaDireccionDomicilio == true) {
      // MensajeTemporal.mostrarMensaje('Agrega un alias y las indicaciones de entrega para completar tu dirección de domicilio.', 'alerta', 4000);
      this.cerrarModalNuevaDireccion();
      return;
    }

    if (this.estadoFaseNuevaDireccion == 1) {
      this.cerrarModalNuevaDireccion();
    }

    if (this.estadoFaseNuevaDireccion == 2) {
      this.modalContenidoF1NuevaDireccion.style.display = "flex";
      this.footerModalNuevaDireccion.style.display = "none";
      this.modalContenidoF2NuevaDireccion.style.display = "none";
      this.estadoFaseNuevaDireccion = 1;
      this.coordenadasProcesoNuevaDireccion = null;
      this.btnProcesoPrincipalNd.classList.remove("desactivado");
    }

    if (this.estadoFaseNuevaDireccion == 3) {
      if (this.huboPreSeleccionaDireccionDomicilio == true) {
        this.coordenadas = {
          lat: this.direccionSeleccionado.lat,
          lng: this.direccionSeleccionado.lng,
        };
        this.procesoMiUbicacionActualF1();
        console.log(
          `Coordenadas de la dirección seleccionada: ${this.direccionSeleccionado.lat}, ${this.direccionSeleccionado.lng}`
        );
      }
      this.modalContenidoF2NuevaDireccion.style.display = "flex";
      this.footerModalNuevaDireccion.style.display = "flex";
      this.modalContenidoF3NuevaDireccion.style.display = "none";
      this.etiquetaBtnModalNuevaDireccion.textContent = "CONFIRMAR DIRECCION";
      this.estadoFaseNuevaDireccion = 2;
      this.coordenadasProcesoNuevaDireccion = null;
      this.btnProcesoPrincipalNd.classList.remove("desactivado");
    }
  }

  procesoMiUbicacionActualF1() {
    this.estadoFaseNuevaDireccion = 2;
    this.modalContenidoF1NuevaDireccion.style.display = "none";
    this.modalContenidoF2NuevaDireccion.style.display = "flex";
    this.footerModalNuevaDireccion.style.display = "flex";
    this.etiquetaBtnModalNuevaDireccion.textContent = "CONFIRMAR DIRECCION";

    // 0. Limpiar referencias anteriores si existen
    this.limpiarReferenciasMapa();

    // 1. Verificar contenedor
    if (!this.contenedorModalMapaNuevaDireccion) {
      alert("Error: No se pudo cargar el mapa. Por favor recarga la página");
      return;
    }

    // 2. Mostrar mensaje de carga ANTES de crear el mapa
    this.crearElementoCargandoUbicacion();
    this.mostrarElementoCargandoUbicacion();

    // 3. Variables de control
    // this.ubicacionObtenida = false;
    this.mapa = null;
    this.marcadorMovible = null;

    console.log("🌍 Iniciando proceso de ubicación...");

    // 4. Verificar si ya tiene coordenadas previas O hay preselección
    if (
      this.coordenadasProcesoNuevaDireccion != null ||
      this.huboPreSeleccionaDireccionDomicilio
    ) {
      console.log("📍 Usando coordenadas previas o preselección");
      this.coordenadas =
        this.coordenadasProcesoNuevaDireccion || this.coordenadas;
      this.crearMapaConUbicacion();
      return;
    }

    // 5. SOLO si no hay coordenadas previas, pedir ubicación GPS
    if (this.ubicacionObtenida == true) return;

    if (navigator.geolocation) {
      console.log("📱 Solicitando permiso de ubicación...");

      navigator.geolocation.getCurrentPosition(
        // ✅ ÉXITO: Usuario acepta y GPS funciona
        (position) => {
          console.log("✅ Ubicación GPS obtenida con éxito");

          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          this.coordenadasProcesoNuevaDireccion = userLocation;
          this.coordenadas = userLocation;
          // this.ubicacionObtenida = true;

          console.log("📍 Ubicación GPS:", userLocation);

          // Ahora SÍ crear el mapa con la ubicación real
          this.crearMapaConUbicacion();
        },

        // ❌ ERROR: Usuario rechaza o GPS falla
        (error) => {
          console.warn("⚠️ Error o rechazo de GPS:", error.message);
          console.log("📍 Usando ubicación por defecto");

          // Usar coordenadas por defecto
          this.coordenadasProcesoNuevaDireccion = this.coordenadas;
          // this.ubicacionObtenida = true;

          // Crear mapa con ubicación por defecto
          this.crearMapaConUbicacion();
        },

        // ⚙️ OPCIONES
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      // ❌ Navegador no soporta geolocalización
      console.warn("❌ Geolocalización no soportada");
      console.log("📍 Usando ubicación por defecto");

      this.coordenadasProcesoNuevaDireccion = this.coordenadas;
      this.mapa.panTo(this.coordenadasProcesoNuevaDireccion);
      this.ubicacionObtenida = true;
      this.crearMapaConUbicacion();
    }
  }

  // Método para crear el mapa SOLO cuando ya tenemos ubicación
  crearMapaConUbicacion() {
    console.log("🗺️ Creando mapa con ubicación:", this.coordenadas);

    // Verificar que tenemos coordenadas válidas
    if (!this.coordenadas || !this.coordenadas.lat || !this.coordenadas.lng) {
      console.error("❌ Error: Coordenadas inválidas:", this.coordenadas);
      alert("Error: No se pudo obtener una ubicación válida");
      return;
    }

    // Ocultar mensaje de carga
    this.ocultarElementoCargandoUbicacion();

    // Crear el mapa con la ubicación final
    this.mapa = new google.maps.Map(this.contenedorModalMapaNuevaDireccion, {
      center: this.coordenadas,
      zoom: 16,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: true,
      scaleControl: false,
      rotateControl: false,
      panControl: false,
      disableDefaultUI: false,
    });

    // Crear elemento de mensaje SIN COBERTURA
    this.crearElementoSinCobertura();

    // Crear el marcador movible
    this.marcadorMovible = new google.maps.Marker({
      position: this.coordenadas,
      map: this.mapa,
      draggable: true,
      animation: google.maps.Animation.DROP,
    });

    // Verificar que el marcador se creó correctamente
    if (!this.marcadorMovible) {
      console.error("❌ Error: No se pudo crear el marcador");
      alert("Error al crear el marcador. Por favor recarga la página");
      return;
    }

    console.log("✅ Marcador creado correctamente en:", this.coordenadas);

    // Validar cobertura inicial
    this.validarCobertura(this.coordenadas.lat, this.coordenadas.lng);

    // Configurar eventos del marcador
    this.marcadorMovible.addListener("dragend", (evento) => {
      try {
        const posicion = this.marcadorMovible.getPosition();
        this.coordenadas = { lat: posicion.lat(), lng: posicion.lng() };
        this.coordenadasProcesoNuevaDireccion = this.coordenadas;

        console.log(
          "📍 Coordenadas actualizadas por usuario:",
          this.coordenadas
        );

        this.mapa.panTo(posicion);
        this.validarCobertura(this.coordenadas.lat, this.coordenadas.lng);
      } catch (error) {
        alert("Error al mover el marcador. Por favor recarga la página");
        console.error("Error al mover el marcador:", error);
      }
    });

    console.log("✅ Mapa y marcador listos para usar");
  }

  // Crear elemento de "Obteniendo ubicación..."
  crearElementoCargandoUbicacion() {
    if (this.elementoCargandoUbicacion) return;

    this.elementoCargandoUbicacion = document.createElement("div");
    this.elementoCargandoUbicacion.innerHTML = `
      <div class="loading-ubicacion" style="
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #c8102e;
        color: white;
        padding: 20px 30px;
        border-radius: 0.25rem;
        font-family: Arial, sans-serif;
        font-size: 16px;
        font-weight: 500;
        box-shadow: 0 6px 20px rgba(0,0,0,0.2);
        z-index: 1000;
        display: none;
        flex-direction: column;
        align-items: center;
        gap: 15px;
        text-align: center;
      ">
        <div style="
          width: 40px;
          height: 40px;
          border: 3px solid white;
          border-top: 3px solid transparent;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        "></div>
        <div>
          <div style="font-weight: bold; margin-bottom: 5px;"><p>Obteniendo tu ubicación</p></div>
          <div style="font-size: 13px; opacity: 0.9;"><p>Permite el acceso para una mejor experiencia</p></div>
        </div>
      </div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;

    this.contenedorModalMapaNuevaDireccion.style.position = "relative";
    this.contenedorModalMapaNuevaDireccion.appendChild(
      this.elementoCargandoUbicacion
    );
  }

  mostrarElementoCargandoUbicacion() {
    if (this.elementoCargandoUbicacion) {
      const loadingDiv =
        this.elementoCargandoUbicacion.querySelector(".loading-ubicacion");
      if (loadingDiv) {
        loadingDiv.style.display = "flex";
      }
    }
  }

  ocultarElementoCargandoUbicacion() {
    if (this.elementoCargandoUbicacion) {
      const loadingDiv =
        this.elementoCargandoUbicacion.querySelector(".loading-ubicacion");
      if (loadingDiv) {
        loadingDiv.style.display = "none";
      }
    }
  }

  limpiarReferenciasMapa() {
    this.ubicacionObtenida = false;

    if (this.elementoCargandoUbicacion) {
      this.elementoCargandoUbicacion.remove();
      this.elementoCargandoUbicacion = null;
    }
    if (this.marcadorMovible) {
      this.marcadorMovible.setMap(null);
      this.marcadorMovible = null;
    }
    if (this.mapa) {
      this.mapa = null;
    }
  }

  async procesoPrincipalNuevaDireccion() {
    if (this.estadoFaseNuevaDireccion == 2) {
      this.estadoFaseNuevaDireccion = 3;
      this.modalContenidoF2NuevaDireccion.style.display = "none";
      this.modalContenidoF3NuevaDireccion.style.display = "flex";
      this.footerModalNuevaDireccion.style.display = "flex";

      this.etiquetaBtnModalNuevaDireccion.textContent =
        this.huboPreSeleccionaDireccionDomicilio == true
          ? "CONTINUAR"
          : "GUARDAR DIRECCION";
      this.btnProcesoPrincipalNd.classList.add("desactivado");
      return;
    }

    if (this.estadoFaseNuevaDireccion == 3) {
      this.etiquetaBtnModalNuevaDireccion.textContent = "CONFIRMAR DIRECCION";
      const alias = this.inputAliasDireccionF3.value;
      const indicaciones = this.inputIndicacionesDireccionF3.value;

      // Desde aqui se va evaluar el this.huboPreSeleccionaDireccionDomicilio
      if (this.huboPreSeleccionaDireccionDomicilio == true) {
        console.log(
          "Hubo preselección de dirección de domicilio, actualizando la última dirección guardada..."
        );

        // Modificar el último elemento de la lista en lugar de hacer push
        const ultimoIndice = this.listaDireccionesGuardadas.length - 1;

        if (ultimoIndice >= 0) {
          // Mantener las coordenadas originales, solo actualizar indicaciones y alias
          this.listaDireccionesGuardadas[ultimoIndice].indicaciones =
            indicaciones;
          this.listaDireccionesGuardadas[ultimoIndice].alias = alias;
        }

        this.etiquetaIndicacionesDireccion.textContent =
          indicaciones == "" ? coordenadasTexto : indicaciones;
        this.etiquetaAliasDireccion.textContent = alias;
        this.direccionSeleccionado =
          this.listaDireccionesGuardadas[
          this.listaDireccionesGuardadas.length - 1
          ];
        console.log("Seleccionando local : ", this.sucursal);
      } else {
        // No hubo preseleccion, tons el flujo seria el procso normal de agregar una nueva
        // direccion de envio al usuario :
        // - Usar mi ubicaicon actual
        // - Seleccionar mapa (pin)
        // - Guardar direccion (Alias) - (Indicaciones)
        console.log(
          "Hubo preselección de dirección de domicilio : ",
          this.huboPreSeleccionaDireccionDomicilio
        );

        const coordenadasTexto =
          await AuxiliaresGlobal.obtenerDireccionDesdeCoordenadas(
            this.coordenadas.lat,
            this.coordenadas.lng
          );
        this.listaDireccionesGuardadas.push({
          lat: this.coordenadas.lat,
          lng: this.coordenadas.lng,
          indicaciones: indicaciones == "" ? coordenadasTexto : indicaciones,
          alias: alias,
        });

        this.etiquetaIndicacionesDireccion.textContent =
          indicaciones == "" ? coordenadasTexto : indicaciones;
        this.etiquetaAliasDireccion.textContent = alias;
        this.direccionSeleccionado =
          this.listaDireccionesGuardadas[
          this.listaDireccionesGuardadas.length - 1
          ];

        this.direccionSeleccionado = {
          lat: this.coordenadas.lat,
          lng: this.coordenadas.lng,
          indicaciones: indicaciones == "" ? coordenadasTexto : indicaciones,
          alias: alias,
        };

        this.sucursal = AuxiliaresGlobal.obtenerSucursalTrabajo(
          { lat: this.coordenadas.lat, lng: this.coordenadas.lng }
        );
        localStorage.setItem(
          "sucursal-informacion",
          JSON.stringify(this.sucursal)
        );
        this.localSeleccionado = this.sucursal;
        if (this.etiquetaLocalSeleccionadoPrincipal) {
          this.etiquetaLocalSeleccionadoPrincipal.textContent = this.sucursal.nombre;
        }
        console.log("Nueva direccion - Sucursal asignada: ", this.sucursal);
      }

      if (this.tipoUsuario == "call_center") {
      } else {
        MensajeCargaDatos.mostrar("Guardando dirección ...");
        const datosUsuario = JSON.parse(
          localStorage.getItem("ph-datos-usuario")
        );
        const informacion =
          await GestorClienteShopify.actualizarMetaFieldDireccionCliente(this);
        console.log("Información de dirección guardada:", informacion);
        datosUsuario.direcciones = informacion.direcciones;
        localStorage.setItem("ph-datos-usuario", JSON.stringify(datosUsuario));

        MensajeCargaDatos.ocultar();
        this.btnProcesoPrincipalNd.classList.add("desactivado");
        this.coordenadasProcesoNuevaDireccion = null;
      }

      // Limpiar los inputs correspondientes y habilitar de nuevo el boton
      this.inputAliasDireccionF3.value = "";
      this.inputIndicacionesDireccionF3.value = "";
      this.btnProcesoPrincipalNd.classList.remove("desactivado");
      if (this.huboPreSeleccionaDireccionDomicilio == true) {
        this.huboPreSeleccionaDireccionDomicilio = false;
      }
      this.cerrarModalNuevaDireccion();
      await this.inspeccionTodosProductosCarrito();
      return;
    }
  }

  async btnAccionDatosContacto(btnElemento) {
    try {
      const accion = btnElemento.dataset.accion;
      const usuarioAntiguoLocalStorage = JSON.parse(
        localStorage.getItem("ph-datos-usuario") || "{}"
      );

      if (accion == "editar") {
        // Cambiar a modo edición
        this.btnEditarDatos.style.display = "none";
        this.btnGuardarDatos.style.display = "flex";
        this.contenedorDatosContactoEditar.style.display = "flex";
        this.contenedorDatoContactoConsolidados.style.display = "none";

        // Llenar inputs con valores actuales (usar .value, no .textContent)
        this.inputNombreContacto.value =
          usuarioAntiguoLocalStorage.nombre || "";
        this.inputApellidoContacto.value =
          usuarioAntiguoLocalStorage.apellido || "";
        this.inputCorreoElectronico.value =
          usuarioAntiguoLocalStorage.email || "";
        this.inputCelularContacto.value =
          usuarioAntiguoLocalStorage.celular || "";
        this.inputCIContacto.value = usuarioAntiguoLocalStorage.ci || "";
        return;
      }

      if (accion == "guardar") {
        MensajeCargaDatos.mostrar("Procesando datos...");

        // Validar campos requeridos
        if (!this.validarCamposFormDatosContacto()) {
          MensajeCargaDatos.ocultar();
          return;
        }

        // Llamar al proceso de actualización
        await GestorClienteShopify.procesoActualizarDatosUsuario({
          nombre: this.inputNombreContacto.value.trim(),
          apellido: this.inputApellidoContacto.value.trim(),
          email: this.inputCorreoElectronico.value.trim(),
          celular: this.inputCelularContacto.value.trim(),
          ci: this.inputCIContacto.value.trim(),
          nit: usuarioAntiguoLocalStorage.nit || "",
          razon_social: usuarioAntiguoLocalStorage.razon_social || "",
          fecha_nacimiento: usuarioAntiguoLocalStorage.fecha_nacimiento || "",
          permisosHutCoins:
            usuarioAntiguoLocalStorage.permisosHutCoins || false,
          direcciones: usuarioAntiguoLocalStorage.direcciones || [],
        });

        // Obtener datos actualizados
        const datosNuevosUsuario = JSON.parse(
          localStorage.getItem("ph-datos-usuario") || "{}"
        );

        // Verificar que se guardaron correctamente
        if (!datosNuevosUsuario.id) {
          MensajeCargaDatos.ocultar();
          return;
        }

        // Actualizar etiqueta consolidada
        this.etiquetaDatosConsolidados.textContent = `${datosNuevosUsuario.nombre || ""
          } | ${datosNuevosUsuario.apellido || ""} | ${datosNuevosUsuario.email || ""
          } | ${datosNuevosUsuario.celular || ""} | ${datosNuevosUsuario.ci || ""
          }`;

        // Restaurar vista a modo lectura
        this.btnEditarDatos.style.display = "flex";
        this.btnGuardarDatos.style.display = "none";
        this.contenedorDatosContactoEditar.style.display = "none";
        this.contenedorDatoContactoConsolidados.style.display = "flex";

        MensajeCargaDatos.ocultar();
      }
    } catch (error) {
      console.error("Error en btnAccionDatosContacto:", error);
      MensajeCargaDatos.ocultar();
      MensajeTemporal.mostrarMensaje(
        "Error inesperado al procesar los datos",
        "error",
        3500
      );
    }
  }

  async btnAccionDatosFacturacion(btnElemento) {
    const accion = btnElemento.dataset.accion;

    if (accion == "editar") {
      this.btnEditarDatosFacturacion.style.display = "none";
      this.btnGuardarDatosFacturacion.style.display = "flex";
      this.contenedorDatosFacturacion.style.display = "flex";
      this.contenedorDatosFacturacionConsolidados.style.display = "none";
    } else {
      MensajeCargaDatos.mostrar("Actualizando datos ...");
      this.btnEditarDatosFacturacion.style.display = "flex";
      this.btnGuardarDatosFacturacion.style.display = "none";
      this.contenedorDatosFacturacion.style.display = "none";
      this.contenedorDatosFacturacionConsolidados.style.display = "flex";

      if (this.inputRazonSocial.value == "" || this.inputNitoCit.value == "") {
        MensajeCargaDatos.ocultar();
        return;
      }

      const infoCliente = JSON.parse(localStorage.getItem("ph-datos-usuario"));
      // await this.editarNITyRazonSocial(infoCliente.id);
      console.log(
        "Actualizando NIT y Razón Social del cliente en Shopify...",
        infoCliente.id
      );
      await GestorClienteShopify.editarNITyRazonSocial({
        id: infoCliente.id,
        nit: this.inputNitoCit.value.trim(),
        razon_social: this.inputRazonSocial.value.trim(),
        fecha_nacimiento: infoCliente.fecha_nacimiento,
        permisosHutCoins: infoCliente.permisosHutCoins,
        direcciones: infoCliente.direcciones,
      });

      // Proceso de guardar datos
      // const data = JSON.parse(localStorage.getItem("ph-datos-facturacion"));
      const datosActualizados = {
        razonsocial: this.inputRazonSocial.value,
        nit: this.inputNitoCit.value,
      };

      const datosUsuario = JSON.parse(localStorage.getItem("ph-datos-usuario"));
      datosUsuario.razon_social = this.inputRazonSocial.value;
      datosUsuario.nit = this.inputNitoCit.value;
      localStorage.setItem("ph-datos-usuario", JSON.stringify(datosUsuario));

      // Actualizar los datos en el localStorage
      localStorage.setItem(
        "ph-datos-facturacion",
        JSON.stringify(datosActualizados)
      );

      // Actualizar la interfaz
      this.inputRazonSocial.textContent = datosUsuario.razon_social;
      this.inputNitoCit.textContent = datosUsuario.nit;

      this.etiquetaDatosFacturacionConsolidados.textContent = `${datosUsuario.razon_social} | ${datosUsuario.nit}`;
      MensajeCargaDatos.ocultar();
    }
  }

  validarCamposFormDatosContacto() {
    const formulario = {
      nombre: this.inputNombreContacto.value.trim(),
      apellido: this.inputApellidoContacto.value.trim(),
      email: this.inputCorreoElectronico.value.trim(),
      celular: this.inputCelularContacto.value.trim(),
      ci: this.inputCIContacto.value.trim(),
    };

    const mensajesError = {
      nombre: this.alertaNombreContacto,
      apellido: this.alertaApellidoContacto,
      email: this.alertaCorreoElectronico,
      celular: this.alertaCelularContacto,
      ci: this.alertaCIContacto,
    };

    // Variable para rastrear contenedores con errorr
    const contenedoresConError = [];

    // Verificar campos vacíos
    let hayCampoVacio = false;

    Object.keys(formulario).forEach((key) => {
      if (!mensajesError[key]) return;

      const contenedorPadre = mensajesError[key].closest(
        ".smecph-pc-info-input"
      );

      // Validación especial para el campo email
      if (key == "email") {
        // Mostrar error si email está vacío O contiene "pizzahut"
        const contienePizzaHut = formulario[key]
          .toLowerCase()
          .includes("pizzahut");

        if (formulario[key] == "" || contienePizzaHut) {
          // Mostrar error de email
          mensajesError[key].style.display = "flex";

          if (contenedorPadre) {
            contenedorPadre.classList.add("error");
            contenedoresConError.push(contenedorPadre);
          }

          hayCampoVacio = true;
        } else {
          // Email válido - ocultar error
          mensajesError[key].style.display = "none";

          if (contenedorPadre) {
            contenedorPadre.classList.remove("error");
          }
        }
      } else {
        // Para el resto de campos, validación normal (solo campo vacío)
        if (formulario[key] == "") {
          // Campo vacío - mostrar error
          mensajesError[key].style.display = "flex";

          if (contenedorPadre) {
            contenedorPadre.classList.add("error");
            contenedoresConError.push(contenedorPadre);
          }

          hayCampoVacio = true;
        } else {
          // Campo con valor - ocultar error
          mensajesError[key].style.display = "none";

          if (contenedorPadre) {
            contenedorPadre.classList.remove("error");
          }
        }
      }
    });

    // Si hay campos vacíos, programar limpieza de errores
    if (hayCampoVacio) {
      this.mensajeInfoCelularContacto.style.display = "none";
      setTimeout(() => {
        // Quitar la clase de error pero mantener mensajes visibles
        contenedoresConError.forEach((contenedor) => {
          contenedor.classList.remove("error");
        });
        // Ocultar todos los mensajes de alerta
        Object.values(mensajesError).forEach((alerta) => {
          if (alerta) {
            alerta.style.display = "none";
          }
        });

        // Volver a mostrar el mensaje informativo
        this.mensajeInfoCelularContacto.style.display = "flex";
      }, 5000); // 5 segundos
    }

    return !hayCampoVacio; // Retorna true si no hay campos vacíos
  }

  validarSeleccionMetodoPago() {
    let haySeleccionado = false;

    for (const btn of this.btnsMetodosPagos) {
      if (btn.classList.contains("seleccionado")) {
        haySeleccionado = true;
        break; // Termina el bucle al encontrar el primer botón seleccionado
      }
    }

    return haySeleccionado;
  }

  validarCamposFormTarjeta() {
    const formulario = {
      primerInput: this.inputPrimero4Digitos.value.trim(),
      segundoInput: this.inputSegundo4Digitos.value.trim(),
    };

    const mensajesError = {
      primerInput: this.mensajeAlertaPrimero4Digitos,
      segundoInput: this.mensajeAlertaSegundo4Digitos,
    };

    // Variable para rastrear contenedores con error
    const contenedoresConError = [];

    // Verificar campos vacíos
    let hayCampoVacio = false;

    Object.keys(formulario).forEach((key) => {
      if (!mensajesError[key]) return;

      const contenedorPadre = mensajesError[key].closest(
        ".smecph-pc-info-input"
      );

      if (formulario[key] == "") {
        // Campo vacío - mostrar error
        mensajesError[key].style.display = "flex";

        if (contenedorPadre) {
          contenedorPadre.classList.add("error");
          contenedoresConError.push(contenedorPadre);
        }

        hayCampoVacio = true;
      } else {
        // Campo con valor - ocultar error
        mensajesError[key].style.display = "none";

        if (contenedorPadre) {
          contenedorPadre.classList.remove("error");
        }
      }
    });

    // Si hay campos vacíos, programar limpieza de errores
    if (hayCampoVacio) {
      setTimeout(() => {
        // Quitar la clase de error pero mantener mensajes visibles
        contenedoresConError.forEach((contenedor) => {
          contenedor.classList.remove("error");
        });
        // Ocultar todos los mensajes de alerta
        Object.values(mensajesError).forEach((alerta) => {
          if (alerta) {
            alerta.style.display = "none";
          }
        });
      }, 5000); // 5 segundos
    }

    return !hayCampoVacio; // Retorna true si no hay campos vacíos
  }

  procesoSeleccionMetodoPago(btnElemento) {
    const accion = btnElemento.dataset.accion;
    const estaSeleccionado = btnElemento.classList.contains("seleccionado");

    if (estaSeleccionado == true) return;

    this.btnsMetodosPagos.forEach((btn) => {
      btn.classList.remove("seleccionado");
      const iconoDesSeleccionado = btn.querySelector(
        ".smecph-pc-dp-item-icono"
      );
      iconoDesSeleccionado.innerHTML = window.shopIcons.icon_estado_off;
    });

    if (estaSeleccionado == false) {
      this.mensajeAlertaDatosFacturacion.style.display = "none";
      btnElemento.classList.add("seleccionado");
      const iconoSeleccionado = btnElemento.querySelector(
        ".smecph-pc-dp-item-icono"
      );
      iconoSeleccionado.innerHTML = window.shopIcons.icon_estado_on;
    }

    this.metodoPagoSeleccionado = accion;
    localStorage.setItem("ph-checkout-metodo-pago", accion);

    // if(accion == "qr"){}
    // if(accion == "efectivo"){}
    if (accion == "tarjeta") {
      this.opcionesTarjetaCredito.style.display = "flex";
    } else {
      this.opcionesTarjetaCredito.style.display = "none";
    }
  }

  intentoAutoSeleccionMetodoPago() {
    const accionGuardada = localStorage.getItem("ph-checkout-metodo-pago");
    if (!accionGuardada) return; // ← Faltaba la 'n' en return

    this.metodoPagoSeleccionado = accionGuardada;

    if (accionGuardada) {
      // Buscar el botón que corresponde a la acción guardada
      const btnSaved = Array.from(this.btnsMetodosPagos).find(
        (btn) => btn.dataset.accion == accionGuardada
      );

      if (btnSaved) {
        // Simular click en el botón guardado
        this.procesoSeleccionMetodoPago(btnSaved);
      }
    }
  }

  procesoVerDetallesProducto(elementoHTML) {
    const hijoDetalle = elementoHTML.querySelector(
      ".smecph-pc-item-carrito-extra"
    );
    if (hijoDetalle == null) return;

    const seraVisto = hijoDetalle.dataset.seravisto;

    if (seraVisto == "true") {
      if (hijoDetalle.style.display == "none") {
        hijoDetalle.style.display = "flex";
      } else {
        hijoDetalle.style.display = "none";
      }
    }
  }



  procesoHutCoins(btnElemento) {
    const estaActivado = btnElemento.classList.contains("seleccionado");
    if (estaActivado == true) {
      btnElemento.classList.remove("seleccionado");
      btnElemento.innerHTML = window.shopIcons.icon_checkbox_off;
    } else {
      btnElemento.classList.add("seleccionado");
      btnElemento.innerHTML = window.shopIcons.icon_checkbox_on;
    }
  }

  async procesoContinuarGeneral() {
    if (this.procesandoPedido) {
      MensajeTemporal.mostrarMensaje(
        "¡Ya estás procesando un pedido! Por favor, espera a que termine el proceso anterior.",
        "alerta",
        3000
      );
      return;
    }


    if (
      this.tienenStockLosProductosCarrito == "no" ||
      this.cantidadProductosCarrito == 0
    ) {
      const elemento = this.seccionCarritoDatos;
      const y =
        elemento.getBoundingClientRect().top +
        window.scrollY -
        window.innerHeight / 2;
      window.scrollTo({ top: y, behavior: "smooth" });
      if (this.cantidadProductosCarrito == 0) {
        MensajeTemporal.mostrarMensaje(
          "¡Tu carrito está vacío! Agrega algunos productos para continuar",
          "alerta",
          3000
        );
      }
      return;
    }

    if (
      this.localSeleccionado == null &&
      this.estadoPagina == "local" &&
      this.etiquetaLocalSeleccionadoPrincipal.textContent == ""
    ) {
      this.contenedorBaseSeleccionLocal.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }

    if (!this.validarCamposFormDatosContacto()) {
      this.btnEditarDatos.style.display = "none";
      this.btnGuardarDatos.style.display = "flex";
      this.contenedorDatosContactoEditar.style.display = "flex";
      this.contenedorDatoContactoConsolidados.style.display = "none";
      this.seccionFormDatosContacto.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }

    if (!this.valirdarSeleccionMetodoPago()) {
      this.seccionGeneralMetodosPago.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }

    if (this.estadoPagina == "domicilio") {
      // Validar si la sucursal tiene habilitado el servicio de envio a domicilio
      const tieneEnvioADomicilio = this.sucursal?.servicios?.some(
        (s) => s.toLowerCase() == "envio a domicilio"
      );
      if (this.sucursal && !tieneEnvioADomicilio) {
        MensajeTemporal.mostrarMensaje(
          `La sucursal ${this.sucursal.nombre} no tiene envio a domicilio disponible. Puedes seleccionar "Recoger en local" para continuar con tu pedido.`,
          "alerta",
          5000
        );
        this.contenedorBaseSeleccionDireccionEnvio.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        return;
      }

      // Coordenadas por defecto del sistema
      const coordenadasDefecto = [
        { lat: "-17.51041339757574", lng: "-63.164604605594825" },
        { lat: "-17.783315017953004", lng: "-63.18214577296119" }
      ];

      // Verificar si es dirección por defecto
      const esDireccionDefecto = coordenadasDefecto.some(coord =>
        String(this.direccionSeleccionado.lat) == String(coord.lat) &&
        String(this.direccionSeleccionado.lng) == String(coord.lng)
      ) || this.direccionSeleccionado.indicaciones.includes("Plaza Principal de Warnes");

      if (esDireccionDefecto) {
        this.contenedorBaseSeleccionDireccionEnvio.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        MensajeTemporal.mostrarMensaje(
          "Tu dirección no ha sido personalizada. Por favor, añade tu ubicación e indicaciones reales.",
          "error",
          3500
        );
        return;
      }

      // Verificar cobertura
      const dentroCobertura = GestorCobertura.dentroDelPoligono(
        this.direccionSeleccionado.lat,
        this.direccionSeleccionado.lng
      );

      if (!dentroCobertura) {
        this.contenedorBaseSeleccionDireccionEnvio.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        MensajeTemporal.mostrarMensaje(
          "Tu dirección está fuera de nuestra zona de cobertura. Por favor, selecciona una dirección dentro del área de servicio.",
          "error",
          4000
        );
        return;
      }
    }

    if (
      this.huboPreSeleccionaDireccionDomicilio == true &&
      this.estadoPagina == "domicilio"
    ) {
      this.procesoParaAnadirNuevaDireccion();
      this.modalContenidoF1NuevaDireccion.style.display = "none";
      this.modalContenidoF2NuevaDireccion.style.display = "flex";
      this.footerModalNuevaDireccion.style.display = "flex";
      this.etiquetaBtnModalNuevaDireccion.textContent = "CONTINUAR";
      this.estadoFaseNuevaDireccion = 2;
      this.procesoPrincipalNuevaDireccion();
      return;
    }

    MensajeCargaDatos.mostrar("Su pedido se esta procesando ...");


    this.procesandoPedido = true;
    if (this.btnContinuar) {
      this.btnContinuar.disabled = true;
      this.btnContinuar.style.opacity = "0.5";
      this.btnContinuar.style.cursor = "not-allowed";
    }

    const usuarioLocalStorage = JSON.parse(
      localStorage.getItem("ph-datos-usuario") || "{}"
    );

    try {
      let resultado = null;
      if (this.tipoUsuario == "call_center") {
        resultado = await GestorClienteShopify.procesoManejoClienteEmpleadoCC({
          nombre: this.inputNombreContacto.value,
          apellido: this.inputApellidoContacto.value,
          email: this.inputCorreoElectronico.value,
          celular: this.inputCelularContacto.value,
          ci: this.inputCIContacto.value,
          nit: this.inputNitoCit.value,
          razon_social: this.inputRazonSocial.value,
          fecha_nacimiento: "",
          permisosHutCoins: false,
          direcciones: [this.direccionSeleccionado],
        });
      } else {
        resultado = await GestorClienteShopify.procesoActualizarDatosUsuario({
          nombre: this.inputNombreContacto.value,
          apellido: this.inputApellidoContacto.value,
          email: this.inputCorreoElectronico.value,
          celular: this.inputCelularContacto.value,
          ci: this.inputCIContacto.value,
          nit:
            this.inputNitoCit.value == ""
              ? usuarioLocalStorage.nit
              : this.inputNitoCit.value,
          razon_social:
            this.inputRazonSocial.value == ""
              ? usuarioLocalStorage.razon_social
              : this.inputRazonSocial.value,
          fecha_nacimiento:
            this.inputFechaNacimiento.value == ""
              ? usuarioLocalStorage.fecha_nacimiento
              : this.inputFechaNacimiento.value,
          permisosHutCoins: false,
          direcciones: this.listaDireccionesGuardadas,
        });
      }

      if (resultado && resultado.success == false) {
        this.procesandoPedido = false;
        if (this.btnContinuar) {
          this.btnContinuar.disabled = false;
          this.btnContinuar.style.opacity = "1";
          this.btnContinuar.style.cursor = "pointer";
        }
        MensajeCargaDatos.ocultar();
        return;
      }
    } catch (error) {
      console.error("Error en el proceso:", error);
      this.procesandoPedido = false;
      if (this.btnContinuar) {
        this.btnContinuar.disabled = false;
        this.btnContinuar.style.opacity = "1";
        this.btnContinuar.style.cursor = "pointer";
      }
      MensajeCargaDatos.ocultar();
      return;
    }

    if (this.estadoPagina == "domicilio" && this.direccionSeleccionado?.lat != null && this.direccionSeleccionado?.lng != null) {
      this.sucursal = AuxiliaresGlobal.obtenerSucursalTrabajo({
        lat: this.direccionSeleccionado.lat,
        lng: this.direccionSeleccionado.lng,
      });
      this.localSeleccionado = this.sucursal;
      if (this.etiquetaLocalSeleccionadoPrincipal) {
        this.etiquetaLocalSeleccionadoPrincipal.textContent = this.localSeleccionado.nombre;
      }
      localStorage.setItem("sucursal-informacion", JSON.stringify(this.sucursal));
    }

    const datosCheckout = {
      // Traer datos de metodo de envio seleccionado
      metodo_envio_seleccionado: this.obtenerDatosMetodoEnvio(),
      // Traer datos de metodo facturacion
      info_metodo_pago_seleccionado: this.obtenerDatosPagoSeleccionado(),
      // Traer info facturacion
      info_facturacion: this.obtenerDatosFacturacion(),
      // Inforacion nota para el pedido
      nota_para_envio: this.inputNotaParaElPedido.value,
    };

    localStorage.setItem("ph-datos-checkout", JSON.stringify(datosCheckout));

    const carritoSnapshot = {
      informacionCompleta: JSON.parse(JSON.stringify(this.carrito.informacionCompleta))
    };
    await AuxiliaresGlobal.limpiarCarrito();
    this.cantidadProductosCarrito = 0;

    try {
      const detalleOrden = await GestionOrdenesShopify.crearOrdenCompletada({
        datosCheckout,
        carrito: carritoSnapshot,
        estadoPagina: this.estadoPagina,
        metodoPagoSeleccionado: this.metodoPagoSeleccionado,
        sucursal: this.sucursal,
        localSeleccionado: this.localSeleccionado,
        direccionSeleccionado: this.direccionSeleccionado,
        metodo_pago: this.metodoPagoSeleccionado,
        idQr: this.idQr
      });

      this.orden = detalleOrden.order;
      this.nombreOrden = this.orden.name;

      const totalElementosCarrito = carritoSnapshot.informacionCompleta.items.length;
      const idFulFillmentOrder = await GestionOrdenesShopify.obtenerFulfillmentOrders(this.orden.id, totalElementosCarrito);
      await GestionOrdenesShopify.moverFulfillmentOrder(idFulFillmentOrder, this.sucursal.id);

      const direccion = await AuxiliaresGlobal.obtenerDireccionShopify(this.direccionSeleccionado.lat, this.direccionSeleccionado.lng);

      let respuestaOfiSistema;
      if (window.produccion == 'no') {
        respuestaOfiSistema = { OK: true, orderTrackingUrl: "https://ejemplo.com/order-tracking" };
      } else {
        respuestaOfiSistema = await GestionOrdenesShopify.crearOrdenOfiSistema({
          metodo_pago: this.metodoPagoSeleccionado,
          metodo_entrega: this.estadoPagina == "domicilio" ? "DELIVERY" : "TAKEOUT",
          nombre: this.usuario.nombre,
          apellido: this.usuario.apellido,
          telefono: this.usuario.celular,
          correo: this.usuario.email,
          nit: this.usuario.nit,
          razon_social: this.usuario.razon_social,
          id_sucursal: this.sucursal.backend,
          id_orden: this.orden.name,
          precio_total_orden: this.etiquetaTotal.textContent,
          direccion_envio:
            this.estadoPagina == "domicilio"
              ? {
                alias: this.direccionSeleccionado.alias,
                indicaciones: this.direccionSeleccionado.indicaciones,
                direccion: direccion.address1,
                coordenadas: {
                  lat: this.direccionSeleccionado.lat,
                  lng: this.direccionSeleccionado.lng,
                },
              }
              : {},
          productos: [
            ...carritoSnapshot.informacionCompleta.items.map((item) => {
              return item.properties.estructura;
            }),
          ],
        });
      }

      // La respuesta de OfiSistema puede venir como texto (fetch .text()) u objeto.
      // Formato esperado: { OK, msg, orderTrackingUrl, receiptText, retry }
      let ofiSistema = respuestaOfiSistema;
      if (typeof ofiSistema === "string") {
        try {
          ofiSistema = JSON.parse(ofiSistema);
        } catch (e) {
          console.warn("procesoContinuarGeneral - respuesta OfiSistema no es JSON:", respuestaOfiSistema);
          ofiSistema = {};
        }
      }
      ofiSistema = ofiSistema || {};

      console.log("procesoContinuarGeneral - OfiSistema:", ofiSistema);

      // OfiSistema siempre responde OK:false, así que no se valida ese campo.
      // Solo importa que devuelva un orderTrackingUrl con una URL válida.
      const trackingUrl = typeof ofiSistema.orderTrackingUrl === "string"
        ? ofiSistema.orderTrackingUrl.trim()
        : "";
      if (/^https?:\/\//i.test(trackingUrl)) {
        localStorage.setItem("ph-dragontail", trackingUrl);
      } else {
        console.warn("procesoContinuarGeneral - OfiSistema sin orderTrackingUrl válido:", ofiSistema.orderTrackingUrl);
      }


      localStorage.setItem("ph-checkout-metodo-pago", "efectivo");
      localStorage.setItem("ph-id-orden", this.orden.id);
      localStorage.setItem("ph-estadoDP", "etapa-1");

      //Descomentar para activar sonido de compra finalizada.
      //localStorage.setItem("ph-viene-de-compra-finalizada", "1");

      window.location.replace("/pages/detalle-pedido");
    } catch (error) {
      console.error("Error al procesar pedido:", error);
      MensajeTemporal.mostrarMensaje(
        "Ocurrió un error al procesar tu pedido. Por favor intenta de nuevo.",
        "error",
        4000
      );
    } finally {
      this.procesandoPedido = false;
      if (this.btnContinuar) {
        this.btnContinuar.disabled = false;
        this.btnContinuar.style.opacity = "1";
        this.btnContinuar.style.cursor = "pointer";
      }
      MensajeCargaDatos.ocultar();
    }
  }

  valirdarSeleccionMetodoPago() {
    for (let btn of this.btnsMetodosPagos) {
      if (btn.classList.contains("seleccionado")) {
        if (btn.dataset.accion == "tarjeta") {
          this.inputPrimero4Digitos.value =
            this.inputPrimero4Digitos.value.trim();
          this.inputUltimos4Digitos.value =
            this.inputUltimos4Digitos.value.trim();

          // Verificar que los campos no estén vacíos después de quitar espacios
          if (
            this.inputPrimero4Digitos.value == "" ||
            this.inputUltimos4Digitos.value == ""
          ) {
            return false; // Los campos están vacíos, no es válido
          }
        }

        return true; // Método de pago seleccionado y válid
      }
    }

    // Si termina el ciclo sin encontrar ninguno seleccionado
    return false;
  }

  obtenerDatosMetodoEnvio() {
    if (this.btnMetodoLocal.classList.contains("seleccionado")) {
      return {
        metodo_envio: "local",
        local_seleccionado: this.localSeleccionado,
      };
    }
    if (this.btnMetodoDomicilio.classList.contains("seleccionado")) {
      return {
        metodo_envio: "domicilio",
        info_seleccionada: this.direccionSeleccionado,
      };
    }
  }

  obtenerDatosFacturacion() {
    return {
      razon_social: this.inputRazonSocial.value || "",
      nit: this.inputNitoCit.value || "",
    };
  }

  obtenerDatosPagoSeleccionado() {
    // Buscar el primer botón que tenga la acción que buscamos
    for (let btn of this.btnsMetodosPagos) {
      const accion = btn.dataset.accion;

      // Verificar si este botón está seleccionado
      if (!btn.classList.contains("seleccionado")) continue;

      // Si llegamos aquí, encontramos un botón seleccionado
      if (accion == "qr") {
        return { metodo_pago: "qr" };
      }

      if (accion == "tarjeta") {
        return {
          metodo_pago: "tarjeta",
          tarjeta_primera_4_digitos: this.inputPrimero4Digitos.value,
          tarjeta_segundo_4_digitos: this.inputUltimos4Digitos.value,
        };
      }

      if (accion == "efectivo") {
        return { metodo_pago: "efectivo" };
      }
    }

    // Si no se encontró ningún botón seleccionado
    return null;
  }

  cerrarModalMensajeProceso() {
    this.contenedorBaseModal.style.display = "none";
    this.contenedorBaseMensaje.style.display = "none";
    this.contenedorQR.style.display = "none";
  }

  async procesoEliminarItemCarrito(btnElemento) {
    MensajeCargaDatos.mostrar("Actualizacion Carrito ...");
    const contenedorPadre = btnElemento.closest(".smecph-pc-item-carrito");
    const keyItemCarrito = contenedorPadre.dataset.key;

    // Se procede a eliminar el producto del carrito y recontruir la vista de ese sector
    await AuxiliaresGlobal.eliminarItemCarritoPorKey(keyItemCarrito, 0);
    await this.construccionSeccionItemsCarrito();

    const itemsSeccionCarrito = this.contenedorItemsCarrito.querySelectorAll(
      ".smecph-pc-item-carrito"
    );
    itemsSeccionCarrito.forEach((item) => {
      // Verificar si el item es igual al contenedorPadre
      if (item == contenedorPadre) {
        // Si es así, eliminarlo del DOM
        item.remove();
      }
    });

    // Actualizar la información del carrito
    this.carrito = await AuxiliaresGlobal.obtenerCarritoShopify();

    let totalPrecioCarrito = 0;
    let totalPrecioCarrito_Comparacion = 0;
    const items = this.carrito.informacionCompleta.items;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (!item.properties?.estructura) continue;

      const data = JSON.parse(item.properties.estructura);

      // ✅ Calcular precio individual de este item (igual que en construccionSeccionItemsCarrito)
      let precioTotalItem = data.item_base.precio * data.item_base.cantidad;
      let precioTotalComparacionItem = data.item_base.precio_comparacion == 0
        ? data.item_base.precio * data.item_base.cantidad
        : data.item_base.precio_comparacion * data.item_base.cantidad;

      data.items_principales.productos.forEach((producto) => {
        precioTotalItem += producto.precio * producto.cantidad;
        precioTotalComparacionItem += producto.precio_comparacion == 0
          ? producto.precio * producto.cantidad
          : producto.precio_comparacion * producto.cantidad;
      });

      // Acumular para el total del carrito
      totalPrecioCarrito += precioTotalItem;
      totalPrecioCarrito_Comparacion += precioTotalComparacionItem;
    }

    // Calcular descuento correctamente
    const descuentoTotal = totalPrecioCarrito_Comparacion - totalPrecioCarrito;

    this.etiquetaSubtotal.textContent = `Bs ${totalPrecioCarrito_Comparacion}`;
    this.etiquetaDescuento.textContent = descuentoTotal > 0 ? `Bs ${descuentoTotal}` : `Bs 0`;
    this.etiquetaTotal.textContent =
      this.estadoPagina == "domicilio"
        ? `Bs ${totalPrecioCarrito + window.costoEnvioDomicilio}`
        : `Bs ${totalPrecioCarrito}`;

    this.tienenStockLosProductosCarrito = "no";
    MensajeCargaDatos.ocultar();
  }

  // AUTO COMPLETADO Y SELECCION (PUNTOS DE REFERENCIA) GOOGLE MAPS

  configuracionAutoCompletadoPuntosReferencia() {
    // Verificar que el input existe
    if (!this.inputPuntoReferenciaF1) return;
    // Variable para almacenar el timer del debounce
    let timeoutId = null;
    // Variable para el servicio de Google Places
    this.placesService = new google.maps.places.AutocompleteService();
    // Configurar evento de entrada en el input
    this.inputPuntoReferenciaF1.addEventListener("input", (event) => {
      // Limpiar el timer anterior si existe
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      const query = event.target.value;
      // Si el input está vacío, ocultar sugerencias
      if (!query) {
        this.contenedorResultadosBusquedaReferenciasF1.style.display = "none";
        return;
      }
      // Configurar debounce (500ms)
      timeoutId = setTimeout(() => {
        // Mostrar todos los resultados
        this.buscarSugerenciasSeleccionReferencia(query);
      }, 500);
    });

    // Restauramos el cerrar al hacer clic fuera
    document.addEventListener("click", (e) => {
      if (
        !this.inputPuntoReferenciaF1.contains(e.target) &&
        !this.contenedorResultadosBusquedaReferenciasF1.contains(e.target)
      ) {
        this.contenedorResultadosBusquedaReferenciasF1.style.display = "none";
      }
    });
  }

  buscarSugerenciasSeleccionReferencia(query) {
    // Opciones para la busqueda
    const opcionesBusqueda = {
      input: query,
      componentRestrictions: { country: "BO" },
    };
    // Realizar la busqueda
    this.placesService.getPlacePredictions(
      opcionesBusqueda,
      (predicciones, status) => {
        // Limpiar contenedor de sugerencias
        this.contenedorResultadosBusquedaReferenciasF1.innerHTML = "";
        if (
          status !== google.maps.places.PlacesServiceStatus.OK ||
          !predicciones
        ) {
          this.contenedorResultadosBusquedaReferenciasF1.style.display = "none";
          return;
        }

        // Mostrar todas las sugerencias sin limitar
        const sugerencias = predicciones;

        // Mostrar sugerencias
        sugerencias.forEach((sugerencia) => {
          const elemento = document.createElement("div");
          elemento.className = "smecph-pc-resultado-item-especial";
          // Crear elemento para el nombre del lugar
          const textoElemento = document.createElement("p");
          textoElemento.textContent = sugerencia.description;
          elemento.appendChild(textoElemento);
          // Agregar evento de clic
          elemento.addEventListener("click", () => {
            this.seleccionarPuntoReferencia(sugerencia);
          });
          this.contenedorResultadosBusquedaReferenciasF1.appendChild(elemento);
        });

        // Mostrar el contenedor siempre que haya resultados
        if (sugerencias.length > 0) {
          this.contenedorResultadosBusquedaReferenciasF1.style.display = "flex";
        } else {
          this.contenedorResultadosBusquedaReferenciasF1.style.display = "none";
        }
      }
    );
  }

  seleccionarPuntoReferencia(sugerencia) {
    this.inputPuntoReferenciaF1.value = sugerencia.description;
    // Ocultamos las sugerencias después de seleccionar
    this.contenedorResultadosBusquedaReferenciasF1.style.display = "none";

    // Obtener las coordenadas del lugar seleccionado
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ placeId: sugerencia.place_id }, (resultados, status) => {
      if (status == google.maps.GeocoderStatus.OK && resultados[0]) {
        const location = resultados[0].geometry.location;
        // Convertir el objeto LatLng de Google Maps a un objeto JavaScript simple
        this.coordenadasProcesoNuevaDireccion = {
          lat: location.lat(),
          lng: location.lng(),
        };
        this.coordenadas = this.coordenadasProcesoNuevaDireccion;
        this.procesoMiUbicacionActualF1();
        this.inputPuntoReferenciaF1.value = "";
        this.mapa.panTo(this.coordenadas);
        this.ubicacionObtenida = true;
      } else {
        console.error("Error al obtener las coordenadas:", status);
      }
    });
  }

  // AUTO COMPLETADO Y SELECCION (LOCALES DE VENTAS)
  configuracionAutoCompletadoSeleccionLocal() {
    this.contenedorLocalSeleccionado.addEventListener("click", () => {
      // Si el contenedor ya está visible, ocultarlo
      if (
        this.contenedorResultadosBuquedaLocal.style.display == "block" ||
        this.contenedorResultadosBuquedaLocal.style.display == "flex"
      ) {
        this.contenedorResultadosBuquedaLocal.style.display = "none";
        return;
      }
      this.mostrarTodosLosLocales();
    });

    document.addEventListener("click", (e) => {
      if (
        !this.etiquetaLocalSeleccionadoPrincipal.contains(e.target) &&
        !this.contenedorLocalSeleccionado.contains(e.target) &&
        !this.contenedorResultadosBuquedaLocal.contains(e.target)
      ) {
        this.contenedorResultadosBuquedaLocal.style.display = "none";
      }
    });
  }

  mostrarTodosLosLocales() {
    // Simplemente llamamos a buscarSugerenciasSeleccionLocal sin límite
    if (this.contenedorResultadosBuquedaLocal.style.display == "none") {
      this.buscarSugerenciasSeleccionLocal("");
      this.contenedorResultadosBuquedaLocal.style.display = "flex";
    } else {
      this.contenedorResultadosBuquedaLocal.style.display = "none";
    }
  }

  buscarSugerenciasSeleccionLocal(query) {
    // Filtrar las ubicaciones basadas en la consulta
    let resultados = this.sucursales;

    // Si hay una consulta, filtramos pero mostramos todos los resultados
    if (query) {
      resultados = this.sucursales.filter(
        (location) =>
          location.nombre.toLowerCase().includes(query.toLowerCase()) ||
          location.localizacion.toLowerCase().includes(query.toLowerCase())
      );

      // Ordenar por relevancia (priorizar coincidencias en el nombre)
      resultados.sort((a, b) => {
        const aInName = a.nombre.toLowerCase().includes(query.toLowerCase());
        const bInName = b.nombre.toLowerCase().includes(query.toLowerCase());
        if (aInName && !bInName) return -1;
        if (!aInName && bInName) return 1;
        return 0;
      });
    }

    // No limitamos resultados en ningún caso
    // (Removido el código que limitaba resultados)

    // Limpiar resultados anteriores
    this.contenedorResultadosBuquedaLocal.innerHTML = "";

    // Si hay resultados, mostrar el contenedor
    if (resultados.length > 0) {
      this.contenedorResultadosBuquedaLocal.style.display = "flex";

      // Crear y añadir elementos para cada resultado
      resultados.forEach((location) => {
        const resultadoItem = document.createElement("div");
        resultadoItem.className = "smecph-pc-resultado-item";

        // Crear elemento para el nombre
        const nombreLocal = document.createElement("p");
        nombreLocal.textContent = location.nombre;

        // Crear elemento para la dirección
        const direccionLocal = document.createElement("p");
        direccionLocal.textContent = location.localizacion;

        // Añadir elementos al item
        resultadoItem.appendChild(nombreLocal);
        resultadoItem.appendChild(direccionLocal);

        // Añadir evento de clic para seleccionar este local
        resultadoItem.addEventListener("click", () => {
          this.seleccionarLocal(location);
        });

        // Añadir el item al contenedor de resultados
        this.contenedorResultadosBuquedaLocal.appendChild(resultadoItem);
      });
    } else {
      // Si no hay resultados, ocultar el contenedor
      this.contenedorResultadosBuquedaLocal.style.display = "none";
    }
  }

  async seleccionarLocal(location) {
    this.localSeleccionado = location;
    this.sucursal = location;
    localStorage.setItem("sucursal-informacion", JSON.stringify(location));
    this.etiquetaLocalSeleccionadoPrincipal.textContent = location.nombre;

    // Ocultar sugerencias después de seleccionar
    this.contenedorResultadosBuquedaLocal.style.display = "none";
    // Mostrar detalles del local seleccionado
    const detalleLocal = this.querySelector(".pcktph-seleccion-local-detalle");
    detalleLocal.style.display = "flex";

    const distancia = AuxiliaresGlobal.calcularDistanciaEuclidiana(this.coordenadas, {
      lat: location.lat,
      lng: location.lng,
    });
    this.etiquetaModalLocalSeleccionado.textContent = `Local : ${location.nombre
      } (${distancia.toFixed(2)} Km) de tu ubicación`;
    // Actualizar información del local seleccionado
    const infoLocal = this.querySelector(
      ".pcktph-seleccion-local-detalle-info"
    );
    infoLocal.innerHTML = `<p>${location.nombre}</p>
      <p>+591 ${location.telefono} - ${parseFloat(distancia).toFixed(2)} Km</p>
    `;

    this.tienenStockLosProductosCarrito = "no";
    await this.inspeccionTodosProductosCarrito();
  }

  // AUTO COMPLETADO Y SELECCION (DIRECCIONES DE ENVIO)

  configuracionAutoCompletadoSeleccionDireccion() {
    // Configurar evento para el botón de mostrar/ocultar
    this.contenedorDireccionEnvioSeleccionado.addEventListener("click", () => {
      // Si el contenedor ya está visible, ocultarlo
      if (this.contenedorResultadosBusquedaDireccion.style.display == "flex") {
        this.contenedorResultadosBusquedaDireccion.style.display = "none";
        return;
      }
      this.mostrarTodasDirecciones();
    });

    // Cerrar sugerencias al hacer clic fueraaa
    document.addEventListener("click", (e) => {
      if (
        !this.contenedorResultadosBusquedaDireccion.contains(e.target) &&
        !this.contenedorDireccionEnvioSeleccionado.contains(e.target)
      ) {
        this.contenedorResultadosBusquedaDireccion.style.display = "none";
      }
    });
  }

  mostrarTodasDirecciones() {
    if (this.contenedorResultadosBusquedaDireccion.style.display == "none") {
      this.buscarSugerenciasSeleccionDireccion("", null);
      this.contenedorResultadosBusquedaDireccion.style.display = "flex";
    } else {
      this.contenedorResultadosBusquedaDireccion.style.display = "none";
    }
  }

  buscarSugerenciasSeleccionDireccion(query) {
    // Filtrar las ubicaciones basadas en la consulta
    let resultados = this.listaDireccionesGuardadas.filter(
      (direccion) =>
        direccion.indicaciones.toLowerCase().includes(query.toLowerCase()) ||
        direccion.alias.toLowerCase().includes(query.toLowerCase())
    );

    // Ordenar por relevancia (priorizar coincidencias en el nombre)
    resultados.sort((a, b) => {
      const aInAlias = a.alias.toLowerCase().includes(query.toLowerCase());
      const bInAlias = b.alias.toLowerCase().includes(query.toLowerCase());

      if (aInAlias && !bInAlias) return -1;
      if (!aInAlias && bInAlias) return 1;
      return 0;
    });

    // Limitar resultados si se especifica un límite
    // if (limite && resultados.length > limite) {
    //   resultados = resultados.slice(0, limite);
    // }

    // Limpiar resultados anteriores
    this.contenedorResultadosBusquedaDireccion.innerHTML = "";

    // Si hay resultados, mostrar el contenedor
    if (resultados.length > 0) {
      this.contenedorResultadosBusquedaDireccion.style.display = "flex";

      // Crear y añadir elementos para cada resultado
      resultados.forEach((direccion) => {
        const resultadoItem = document.createElement("div");
        resultadoItem.className = "smecph-pc-resultado-item";

        // Crear elemento para el nombre
        const nombreAlias = document.createElement("p");
        nombreAlias.textContent = direccion.alias;

        // Crear elemento para la dirección
        const direccionIndicacion = document.createElement("p");
        direccionIndicacion.textContent = direccion.indicaciones;

        // Añadir elementos al item
        resultadoItem.appendChild(nombreAlias);
        resultadoItem.appendChild(direccionIndicacion);

        // Añadir evento de clic para seleccionar este locall
        resultadoItem.addEventListener("click", () => {
          this.seleccionarDireccion(direccion);
        });

        // Añadir el item al contenedor de resultados
        this.contenedorResultadosBusquedaDireccion.appendChild(resultadoItem);
      });
    } else {
      // Si no hay resultados, ocultar el contenedor
      this.contenedorResultadosBusquedaDireccion.style.display = "none";
    }
  }

  // async seleccionarDireccion(direccion) {
  //   this.direccionSeleccionado = direccion;
  //   localStorage.setItem(
  //     "ph-direccion-envio-guardada",
  //     JSON.stringify(direccion)
  //   );
  //   this.coordenadas = { lat: direccion.lat, lng: direccion.lng };
  //   this.contenedorResultadosBusquedaDireccion.style.display = "none";
  //   this.etiquetaAliasDireccion.textContent = direccion.alias;
  //   this.etiquetaIndicacionesDireccion.textContent = direccion.indicaciones;

  //   this.sucursal = AuxiliaresGlobal.obtenerSucursalTrabajo(
  //     this.coordenadas
  //   );
  //   localStorage.setItem(
  //     "sucursal-informacion",
  //     JSON.stringify(this.sucursal)
  //   );
  //   console.log("Seleccionando direccion : ", this.sucursal);
  //   this.tienenStockLosProductosCarrito = "no";
  //   await this.inspeccionTodosProductosCarrito();
  // }

  async seleccionarDireccion(direccion) {
    this.direccionSeleccionado = direccion;
    localStorage.setItem(
      "ph-direccion-envio-guardada",
      JSON.stringify(direccion)
    );
    this.coordenadas = { lat: direccion.lat, lng: direccion.lng };
    this.contenedorResultadosBusquedaDireccion.style.display = "none";
    this.etiquetaAliasDireccion.textContent = direccion.alias;
    this.etiquetaIndicacionesDireccion.textContent = direccion.indicaciones;

    // SOLO recalcular la sucursal si es modo domicilio
    // En modo "Recojo en Local" se mantiene la sucursal que el usuario seleccionó
    if (this.estadoPagina == "domicilio") {
      this.sucursal = AuxiliaresGlobal.obtenerSucursalTrabajo(
        this.coordenadas
      );
      localStorage.setItem(
        "sucursal-informacion",
        JSON.stringify(this.sucursal)
      );
      this.localSeleccionado = this.sucursal;
      if (this.etiquetaLocalSeleccionadoPrincipal) {
        this.etiquetaLocalSeleccionadoPrincipal.textContent = this.sucursal.nombre;
      }
      console.log("Seleccionando direccion : ", this.sucursal);
    }

    this.tienenStockLosProductosCarrito = "no";
    await this.inspeccionTodosProductosCarrito();
  }

  // Método para crear el elemento de mensaje SIN COBERTURA
  crearElementoSinCobertura() {
    // Verificar si ya existe el elemento (no debería existir después de limpiarReferenciasMapa)
    if (this.elementoSinCobertura) {
      return;
    }

    this.elementoSinCobertura = document.createElement("div");
    this.elementoSinCobertura.innerHTML = "SIN COBERTURA";
    this.elementoSinCobertura.style.cssText = `
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background-color: var(--colorp-primary, #c8102e);
      color: white;
      padding: 10px 20px;
      font-weight: bold;
      border-radius: 8px;
      z-index: 1000;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      display: none;
      letter-spacing: 2.5px;
    `;

    // Agregar al contenedor del mapa
    this.contenedorModalMapaNuevaDireccion.style.position = "relative";
    this.contenedorModalMapaNuevaDireccion.appendChild(
      this.elementoSinCobertura
    );
  }

  // Método para validar cobertura y mostrar/ocultar mensaje
  validarCobertura(lat, lng) {
    const dentroCobertura = GestorCobertura.dentroDelPoligono(lat, lng);

    if (dentroCobertura) {
      // Dentro de cobertura - ocultar mensaje
      if (this.elementoSinCobertura) {
        this.elementoSinCobertura.style.display = "none";
        if (this.btnProcesoPrincipalNd) {
          this.btnProcesoPrincipalNd.classList.remove("desactivado");
        }
      }
    } else {
      // Fuera de cobertura - mostrar mensaje
      if (this.elementoSinCobertura) {
        this.elementoSinCobertura.style.display = "block";
        if (this.btnProcesoPrincipalNd) {
          this.btnProcesoPrincipalNd.classList.add("desactivado");
        }
      }
    }
  }

  // Método para destruir completamente el mapa (llamar cuando cierres el modal)
  destruirMapa() {
    this.limpiarReferenciasMapa();

    // Limpiar el contenedor del mapa
    if (this.contenedorMapaModal) {
      this.contenedorMapaModal.innerHTML = "";
    }
  }

  limpiarReferenciasMapa() {
    if (this.marcadorMovible) {
      this.marcadorMovible.setMap(null);
      this.marcadorMovible = null;
    }
    if (this.mapa) {
      this.mapa = null;
    }
  }

  // INSPECCION DEL CARRITO DEACUERDO AL LOCAL(SUCURSAL DE TRABAJO)
  async inspeccionTodosProductosCarrito() {
    // Despues de seleccionar se va a traer si el producto esta habilitado de cada producto
    // mediante su titulo se va traer esa informacion respectiva para trabajar y validar
    // correctamente
    MensajeCargaDatos.mostrar("Verificando disponibilidad de productos...");

    try {
      this.carrito = await AuxiliaresGlobal.obtenerCarritoShopify();

      // Verificar si hay elementos en el carrito
      if (
        !this.carrito.informacionCompleta.items ||
        this.carrito.informacionCompleta.items.length == 0
      ) {
        this.cantidadProductosCarrito = 0;
        const elemento = this.seccionCarritoDatos;
        const y =
          elemento.getBoundingClientRect().top +
          window.scrollY -
          window.innerHeight / 2;
        window.scrollTo({ top: y, behavior: "smooth" });
        MensajeCargaDatos.ocultar();
        MensajeTemporal.mostrarMensaje(
          "¡Tu carrito está vacío! Agrega algunos productos para continuar",
          "alerta",
          3000
        );
        return;
      } else {
        this.cantidadProductosCarrito =
          this.carrito.informacionCompleta.items.length;
      }

      // Seleccionar todos los elementos del carrito en el DOM
      var itemsDentroSeccionCarrito = this.querySelectorAll(
        ".smecph-pc-item-carrito"
      );
      let incumplimientoStockGlobal = false;

      // Recuperar información de la sucursal seleccionada
      // const sucursalSeleccionada = JSON.parse(
      //   localStorage.getItem("sucursal-informacion")
      // );

      const sucursalSeleccionada =
        GestionSucursales.corroborarInfoShopify(
          window.sucursales,
          JSON.parse(localStorage.getItem("sucursal-informacion"))
        );


      if (!sucursalSeleccionada) {
        console.error(
          "No se encontró información de la sucursal en localStorage"
        );
        MensajeCargaDatos.ocultar();
        return;
      }

      const productosColeccionesGeneralesCarrito =
        await GestorProductos.obtenerProductosDeColecciones(
          this.coleccionesProductosCarrito
        );

      // Procesamos cada elemento del carrito
      itemsDentroSeccionCarrito.forEach((elementoHTML) => {
        const tipoProducto = elementoHTML.closest(".smecph-pc-item-carrito")
          .dataset.tipoproducto;

        let incumplimientoStock = false; // ✅ Variable local para cada producto

        // PASO 1: PREPARACIÓN Y VERIFICACIÓN INICIAL
        const infoProductoBase = elementoHTML.querySelector(
          ".smecph-pc-item-carrito-info"
        );
        if (!infoProductoBase) return;

        // PASO 2: OPTIMIZACIÓN DE DATOS - CREANDO MAPAS PARA BÚSQUEDA RÁPIDA
        const mapaProductos = new Map();
        const mapaStockSucursal = new Map();

        // Recorremos las colecciones una sola vez para crear ambos mapas
        for (const coleccion of productosColeccionesGeneralesCarrito) {
          for (const producto of coleccion.productos) {
            // Almacenamos el producto completo indexado por su título
            mapaProductos.set(producto.nombre, producto);

            // Buscamos el stock para la sucursal seleccionada y lo guardamos directamente
            let stockProducto = 0;
            for (const sucursal of producto.sucursales) {
              // Al encontrar la sucursal correspondiente, guardamos su stock
              if (sucursal.nombre == sucursalSeleccionada.nombre) {
                stockProducto = sucursal.stock;
                break; // Optimización: salimos del bucle al encontrar la sucursal
              }
            }
            // Guardamos el stock del producto en la sucursal seleccionada
            mapaStockSucursal.set(producto.nombre, stockProducto);
          }
        }

        // PASO 3: PROCESAR EL PRODUCTO BASE (PRINCIPAL)
        const etiquetasP = infoProductoBase.querySelectorAll("p");
        if (etiquetasP.length > 0) {
          // La primera etiqueta p contiene el título del producto
          const tituloProductoBase = etiquetasP[0].textContent;
          // Buscamos el producto en nuestro mapa (búsqueda O(1))
          const productoBaseEncontrado = mapaProductos.get(tituloProductoBase);

          // Si encontramos el producto, verificamos su stock
          if (productoBaseEncontrado) {
            // Obtenemos el stock directamente de nuestro mapa (O(1))
            const stockProductoBase =
              mapaStockSucursal.get(tituloProductoBase) || 0;

            // Determinamos los estilos basados en el stock (una sola vez)
            const tieneStock = stockProductoBase > 0;
            const color = tieneStock ? "" : "var(--colorp-primary)";
            const textDecoration = tieneStock ? "" : "line-through";
            incumplimientoStock = incumplimientoStock || !tieneStock;

            // Aplicamos los estilos a todas las etiquetas p en un solo paso
            for (const etiqueta of etiquetasP) {
              etiqueta.style.color = color;
              etiqueta.style.textDecoration = textDecoration;
            }
          }
        }

        // PASO 4: FUNCIÓN REUTILIZABLE PARA PROCESAR SECCIONES DE PRODUCTOS
        function procesarSeccion(seccion) {
          // Si la sección no existe, no hacemos nada
          if (!seccion) return;

          // Obtenemos todos los elementos p dentro de la sección
          const elementos = seccion.querySelectorAll("p");
          for (const elemento of elementos) {
            // Obtenemos el título del producto desde el texto del elemento
            const titulo = elemento.textContent;
            // Ignoramos elementos que son títulos de sección (contienen ":")
            if (!titulo || titulo.includes(":")) continue;

            if (tipoProducto == "complejo") {
              // Obtenemos el stock directamente del mapa (búsqueda O(1))
              const stock = mapaStockSucursal.get(titulo) || 0;

              // Aplicamos estilos directamente basados en el stock
              elemento.style.color = stock > 0 ? "" : "var(--colorp-primary)";
              elemento.style.textDecoration = stock > 0 ? "" : "line-through";

              // ✅ CORREGIDO: Solo actualizar si aún no se ha detectado incumplimiento
              if (!incumplimientoStock) {
                incumplimientoStock = stock <= 0;
              }
            }
          }
        }

        // PASO 5: PROCESAR LAS OPCIONES PRINCIPALES
        const opcionesPrincipales = elementoHTML.querySelector(
          '[data-seccion="opciones_principales"]'
        );
        procesarSeccion(opcionesPrincipales);

        // PASO 7: EVALUACIÓN FINAL CORREGIDA
        if (incumplimientoStock) {
          infoProductoBase.style.color = "var(--colorp-primary)";
          infoProductoBase.style.textDecoration = "line-through";
          const botonEliminar = elementoHTML.querySelector(
            ".smecph-eliminar-item-cid3"
          );
          botonEliminar.style.display = "flex";
          incumplimientoStockGlobal = true; // ✅ Actualizar variable global
        } else {
          infoProductoBase.style.color = "";
          infoProductoBase.style.textDecoration = "";
          const botonEliminar = elementoHTML.querySelector(
            ".smecph-eliminar-item-cid3"
          );
          botonEliminar.style.display = "none";
        }
      });

      // Ocultar mensaje de carga
      MensajeCargaDatos.ocultar();

      // Mostrar mensaje según estado de stock
      if (incumplimientoStockGlobal) {
        this.tienenStockLosProductosCarrito = "no";
        MensajeTemporal.mostrarMensaje(
          this.estadoPagina == "domicilio"
            ? "Productos sin stock para entrega a domicilio en tu zona"
            : "Productos sin stock en esta sucursal",
          "error",
          3500
        );

        const elemento = this.seccionCarritoDatos;
        const y =
          elemento.getBoundingClientRect().top +
          window.scrollY -
          window.innerHeight / 2;
        window.scrollTo({ top: y, behavior: "smooth" });
      } else {
        this.tienenStockLosProductosCarrito = "si";
      }
    } catch (error) {
      console.error("Error al verificar disponibilidad de productos:", error);
      MensajeCargaDatos.ocultar();
      MensajeTemporal.mostrarMensaje(
        "Ocurrió un error al verificar la disponibilidad de productos. Por favor, intenta nuevamente.",
        "error",
        3500
      );

      const elemento = this.seccionCarritoDatos;
      const y =
        elemento.getBoundingClientRect().top +
        window.scrollY -
        window.innerHeight / 2;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }

  async construccionSeccionItemsCarrito() {
    // Se procede a reconstruir ese sector entre otros valores
    this.carrito = await AuxiliaresGlobal.obtenerCarritoShopify();
    var contenidoHTML = "";
    var totalPrecioCarrito = 0;
    var totalPrecioCarrito_Comparacion = 0;

    this.carrito.informacionCompleta.items.forEach((item) => {

      if (!(item.properties && item.properties.estructura)) return;
      // Verificar si el item tiene la propiedad "estructura"
      const data = JSON.parse(item.properties.estructura);

      // Unificar todas las colecciones
      this.coleccionesProductosCarrito = [
        ...new Set([
          ...this.coleccionesProductosCarrito,
          ...data.colecciones_trabajo,
        ]),
      ];

      // Calcular precio individual de este item (no acumulativo)
      let precioTotalItem = data.item_base.precio * data.item_base.cantidad;
      let precioTotalComparacionItem = data.item_base.precio_comparacion == 0
        ? data.item_base.precio * data.item_base.cantidad
        : data.item_base.precio_comparacion * data.item_base.cantidad;

      data.items_principales.productos.forEach((producto) => {
        precioTotalItem += producto.precio * producto.cantidad;
        precioTotalComparacionItem += producto.precio_comparacion == 0
          ? producto.precio * producto.cantidad
          : producto.precio_comparacion * producto.cantidad;
      });

      // Acumular para el total del carrito
      totalPrecioCarrito += precioTotalItem;
      totalPrecioCarrito_Comparacion += precioTotalComparacionItem;

      // Calcular precio mostrado por unidad (dividir entre cantidad)
      var precioUnitarioMostrado = precioTotalItem / parseInt(data.item_base.cantidad);
      var precioComparacionUnitario = precioTotalComparacionItem > precioTotalItem
        ? precioTotalComparacionItem / parseInt(data.item_base.cantidad)
        : 0;

      contenidoHTML += `
        <div 
        data-tipoproducto="${data.item_base.tipoProducto}"
        data-idTrabajo="${data.item_base.idtrabajo}"
        data-idShopify="${data.item_base.idshopify}"
        data-handle="${data.item_base.handle}"
        data-precio="${data.item_base.precio}"
        data-key="${item.key}"
        class="smecph-pc-item-carrito">
          <div class="smecph-pc-item-carrito-info">
            <div class="smecph-pc-item-ci-img">
            <img src="${data.item_base.imagen}" alt="${data.item_base.nombre}" width="100" height="100">
            </div>
            <div class="smecph-pc-item-ci-detalle">
              <div class="smecph-pc-item-cid1">
                <p>${data.item_base.nombre}</p>
              </div>
              <div class="smecph-pc-item-cid2">
                <p>x${data.item_base.cantidad}</p>
              </div>
              <div class="smecph-pc-item-cid3">
                <button 
                style="display: none;"
                class="smecph-eliminar-item-cid3 icon-color-primary">
                  ${window.shopIcons.icon_basura}
                </button>
               <div class="smecph-pc-item-precios">
                  <div class="smecph-pc-item-cid3_total">
                    <small>Bs</small>
                    <p>${parseInt(precioUnitarioMostrado)}</p>
                  </div>
                  ${precioComparacionUnitario > 0
          ? `<div class="smecph-pc-item-precio-comparacion color-letras-extra">
                        <small>Bs</small>
                        <p>${parseInt(precioComparacionUnitario)}</p>
                      </div>`
          : ``
        }
               </div>
              </div>
            </div>
          </div>
      `;

      // Verificar si hay productos en opciones principales o complementos
      const hayOpcionesPrincipales =
        data.items_principales &&
        data.items_principales.productos &&
        data.items_principales.productos.length > 0;

      // Solo crear el contenedor de extras si hay opciones principales o complementos
      if (hayOpcionesPrincipales) {
        // style="display: none;"
        contenidoHTML += `
        <div 
        data-seravisto="true"
        class="smecph-pc-item-carrito-extra">
      `;

        // Procesar opciones principales si existen
        if (hayOpcionesPrincipales) {
          contenidoHTML += `
        <p>${data.items_principales.titulo}</p>
        <ul data-seccion="opciones_principales" >
      `;

          // Variable para rastrear la sección actual en opciones principales
          let seccionActualOpciones = "";

          data.items_principales.productos.forEach((producto, index) => {
            if (producto.titulo !== seccionActualOpciones) {
              // Si ya estábamos en una sección anterior y cambia, cerramos el <li>
              if (seccionActualOpciones !== "" && index > 0) {
                contenidoHTML += `</li>`;
              }

              // Iniciamos una nueva sección
              seccionActualOpciones = producto.titulo;
              contenidoHTML += `<li> <p>${producto.titulo} : </p><p>${producto.nombre}</p>`;
            } else {
              // Continuamos en la misma sección, solo añadimos el título del producto
              contenidoHTML += `<p>${producto.nombre}</p>`;
            }
          });

          // Cerrar el último <li> si había productos en opciones principales
          if (seccionActualOpciones !== "") {
            contenidoHTML += `</li>`;
          }

          // Cerrar la lista de opciones principales
          contenidoHTML += `</ul>`;
        }

        // Cerrar el contenedor de extras
        contenidoHTML += `</div>`;
      }

      // Cerrar el contenedor principal del item
      contenidoHTML += `</div>`;
    });

    this.totalCarrito = parseInt(totalPrecioCarrito);

    // Calcular descuento correctamente
    const descuentoTotal = totalPrecioCarrito_Comparacion - totalPrecioCarrito;

    this.etiquetaSubtotal.textContent = `Bs ${totalPrecioCarrito_Comparacion}`;
    this.etiquetaDescuento.textContent = descuentoTotal > 0 ? `Bs ${descuentoTotal}` : `Bs 0`;
    this.etiquetaTotal.textContent =
      this.estadoPagina == "domicilio"
        ? `Bs ${totalPrecioCarrito + window.costoEnvioDomicilio}`
        : `Bs ${totalPrecioCarrito}`;

    this.contenedorItemsCarrito.innerHTML = contenidoHTML;
    this.btnsEliminarCarrito = this.querySelectorAll(
      ".smecph-eliminar-item-cid3"
    );

    this.btnsEliminarCarrito.forEach((btn) => {
      btn.addEventListener("click", async () => {
        await this.procesoEliminarItemCarrito(btn, event);
        await this.inspeccionTodosProductosCarrito();
      });
    });

    this.itemProductoCarrito = this.querySelectorAll(".smecph-pc-item-carrito");
    MensajeCargaDatos.ocultar();
  }

  async obtenerUbicacion() {
    try {
      const posicion = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });

      const coordenadas = {
        lat: posicion.coords.latitude,
        lng: posicion.coords.longitude,
      };

      localStorage.setItem(
        "ph-coordenadas-usuario",
        JSON.stringify(coordenadas)
      );
      return coordenadas;
    } catch {
      const coordenadasDefecto = {
        lat: -17.783315017953004,
        lng: -63.18214577296119,
      };

      localStorage.setItem(
        "ph-coordenadas-usuario",
        JSON.stringify(coordenadasDefecto)
      );
      return coordenadasDefecto;
    }
  }
}

customElements.define("page-checkout-ph", PageCheckoutPH);
